declare const __LOCAL__;
declare var G_vmlCanvasManager;
declare var availableCourses;
declare var currentCourse;

import {
    FORCE_LIVEPROJECT_PROD_TO_QA_BACKEND,
    VIDEO_MODULE_TYPE,
    LIVEVIDEO_VIEWER_MODULE_TYPE,
    YEAR_FOR_PROMOTION,
    MONTH_FOR_PROMOTION,
    FORCE_TONI_DEV,
    ROLE_USER,
    FORCE_LOCAL_BACKEND_DEV,
} from '../constants/index'

import * as jQuery from 'jquery';

import { ServiceUtils } from '../adapters/ServiceUtils';
import PlatformUtils from '../adapters/PlatformUtils';
import { CURRENT_APP_LIVEVIDEO, CURRENT_APP_LIVEPROJECT, OPEN_LIVEPROJECT_IN_LOCALHOST } from '../constants';


const url = window.location.href;
const debug = shouldDebug();

var enableLocalStorage = true;
if (typeof localStorage === 'object') {
    try {
        localStorage.setItem('localStorage', "1");
        localStorage.removeItem('localStorage');
    } catch (e) {
        enableLocalStorage = false;
    }
}

export function detectedApp() {
    var url = window.location.href;
    if (
        url.indexOf("livevideo.manning.com") !== -1
        || url.indexOf("livevideo-qa.manning.com") !== -1
        || url.indexOf("livevideo-ui-dev") !== -1
        || url.indexOf("livevideo-ui-prod") !== -1
        || url.indexOf("lv-test-ui") !== -1
        || url.indexOf("d23vewbo0wjc8b.cloudfront.net") !== -1
        || url.indexOf("lv-test-prod-ui") !== -1
        || url.indexOf("livevideo-tokens.manning.com") !== -1
        || (url.indexOf("localhost") !== -1 && !OPEN_LIVEPROJECT_IN_LOCALHOST)
        || (url.indexOf("192.168.0.") !== -1 && !OPEN_LIVEPROJECT_IN_LOCALHOST)
    ) {
        return CURRENT_APP_LIVEVIDEO;
    }
    else if (
        url.indexOf("pbc-qa.manning.com") !== -1
        || url.indexOf("liveproject-qa.manning.com") !== -1
        || url.indexOf("pbc.manning.com") !== -1
        || url.indexOf("liveproject.manning.com") !== -1
        || url.indexOf("lp-test-ui") !== -1
        || url.indexOf("dlc9nze5anfoi.cloudfront.net") !== -1
        || (url.indexOf("localhost") !== -1 && OPEN_LIVEPROJECT_IN_LOCALHOST)
        || (url.indexOf("192.168.0.") !== -1 && OPEN_LIVEPROJECT_IN_LOCALHOST)
    ) {
        return CURRENT_APP_LIVEPROJECT;
    }
    else {
        alert("Possible problem detected")
        return CURRENT_APP_LIVEVIDEO;
    }
}

export function getServerURL() {
    var url = window.location.href;

    const toniDev = 'https://lvdeo.ddns.net:8443';
    const toniDevLocalhost = 'http://localhost:8080';
    const localDev = toniDevLocalhost;
    //const toniDev = '88.207.90.107:8080';
    const backendDev = 'https://livevideo-be-dev.manning.com';
    //const backendDevOld = 'http://livevideo-dev.us-west-2.elasticbeanstalk.com';
    const backendProd = 'https://livevideo-be.manning.com';
    const backendDocker = 'https://livevideo-be-tokens.manning.com';

    if (__LOCAL__) {
        return 'http://localhost:8080';
    }

    if (
        url.indexOf("localhost") !== -1
        || url.indexOf("192.168.0.") !== -1
        || url.indexOf("pbc-qa.manning.com") !== -1
        || url.indexOf("liveproject-qa.manning.com") !== -1
        || (url.indexOf("pbc.manning.com") !== -1 && FORCE_LIVEPROJECT_PROD_TO_QA_BACKEND)
        || (url.indexOf("liveproject.manning.com") !== -1 && FORCE_LIVEPROJECT_PROD_TO_QA_BACKEND)
        || url.indexOf("livevideo-qa.manning.com") !== -1
        || url.indexOf("livevideo-ui-dev") !== -1
    ) {
        if (FORCE_TONI_DEV) return toniDev;
        if (FORCE_LOCAL_BACKEND_DEV) return localDev;
        return backendDev;
    }
    else if (
        url.indexOf("livevideo.manning.com") !== -1
        || (url.indexOf("pbc.manning.com") !== -1 && !FORCE_LIVEPROJECT_PROD_TO_QA_BACKEND)
        || (url.indexOf("liveproject.manning.com") !== -1 && !FORCE_LIVEPROJECT_PROD_TO_QA_BACKEND)
        || url.indexOf("livevideo-ui-prod") !== -1
    ) {
        return backendProd;
    }
    else if (
        url.indexOf("lv-test-ui") !== -1
        || url.indexOf("d23vewbo0wjc8b.cloudfront.net") !== -1
        || url.indexOf("lp-test-ui") !== -1
        || url.indexOf("dlc9nze5anfoi.cloudfront.net") !== -1
        || url.indexOf("lv-test-prod-ui") !== -1
    ) {
        return toniDevLocalhost;
    }
    else if (
        url.indexOf("livevideo-tokens.manning.com") !== -1
    ) {
        return backendDocker;
    }
    else {
        alert("Possible problem detected")
        return backendProd;
    }
}

export function getWebSocketsURL(){
    const serverURL = getServerURL();
    const webSocketURL = serverURL.replace("https://", "ws://").replace("http://", "ws://") + "/certificationFeedback/websocket";
    return webSocketURL;
}

export function getECommerceURL() {
    var url = window.location.href;

    const toniDev = 'https://www.manning.com/';
    const toniDevLocalhost = 'https://www.manning.com/';
    const toniDevHTTPS = 'https://www.manning.com/';
    const backendDev = 'https://www-qa.manning.com/';
    const backendProd = 'https://www.manning.com/';
    const backendDocker = 'https://tokens.manning.com/';

    if (
        url.indexOf("localhost") !== -1
        || url.indexOf("192.168.0.") !== -1
        || url.indexOf("pbc-qa.manning.com") !== -1
        || url.indexOf("liveproject-qa.manning.com") !== -1
        || (url.indexOf("pbc.manning.com") !== -1 && FORCE_LIVEPROJECT_PROD_TO_QA_BACKEND)
        || (url.indexOf("liveproject.manning.com") !== -1 && FORCE_LIVEPROJECT_PROD_TO_QA_BACKEND)
        || url.indexOf("livevideo-qa.manning.com") !== -1
        || url.indexOf("livevideo-ui-dev") !== -1
    ) {
        return backendDev;
    }
    else if (
        url.indexOf("livevideo.manning.com") !== -1
        || (url.indexOf("pbc.manning.com") !== -1 && !FORCE_LIVEPROJECT_PROD_TO_QA_BACKEND)
        || (url.indexOf("liveproject.manning.com") !== -1 && !FORCE_LIVEPROJECT_PROD_TO_QA_BACKEND)
        || url.indexOf("livevideo-ui-prod") !== -1
    ) {
        return backendProd;
    }
    else if (
        url.indexOf("lv-test-ui") !== -1
        || url.indexOf("d23vewbo0wjc8b.cloudfront.net") !== -1
        || url.indexOf("lp-test-ui") !== -1
        || url.indexOf("dlc9nze5anfoi.cloudfront.net") !== -1
        || url.indexOf("lv-test-prod-ui") !== -1
    ) {
        return toniDevLocalhost;
    }
    else if (
        url.indexOf("livevideo-tokens.manning.com") !== -1
    ) {
        return backendDocker;
    }
    else {
        alert("Possible problem detected")
        return backendProd;
    }
}


/*export function getEndTime(time) {

    let allEndTimes = jQuery("div[data-endtime]")

    if (allEndTimes.length > 0) {
        for (let i = 0; i < allEndTimes.length; i++) {
            if (Number(time) >= Number(jQuery(allEndTimes[i]).data("starttime")) && Number(time) < Number(jQuery(allEndTimes[i]).data("endtime"))) {
                return Number(jQuery(allEndTimes[i]).data("endtime"));
            }
        }
    }
    else {
        return time;
    }

}*/


//Third version of getEndTime
export function getEndTimeFromExtractedCueTimings(time, extractedTimings) {
    let result;
    if (extractedTimings != null) {
        extractedTimings.map(it => {
            if (Number(time) == Number(it[0])) {
                result = Number(it[1]);
            }
        })
        if (result != null) {
            return result;
        }
    }
    return time;
}


export function extractSecondsFromCueTrack(cueTrack) {
    let seconds = null;
    cueTrack = cueTrack.toJS();
    if (cueTrack.content != null) {
        seconds = [];
        seconds = cueTrack.content.map(it => {
            let temp = [];
            temp.push(it.startSeconds);
            temp.push(it.endSeconds);
            return temp;
        })
    }
    return seconds
}


export function setUserProgressCommon(currentCourseID, currentUnitIndex, currentModuleIndex, uniqueUnitID, uniqueModuleID, syncOrAsync) {

    let foundData = [];
    let isChangedToBeRestoredAfterSuccess = [];
    for (var i = 0; i < localStorage.length; i++) {


        if (enableLocalStorage) {

            let stringToFind1 = "_currentTime";
            let stringToFind2 = "progress_";
            if (localStorage.key(i).indexOf(stringToFind1) !== -1 && localStorage.key(i).indexOf(stringToFind2) !== -1) {
                let moduleIdenU = localStorage.key(i).replace("_currentTime", "").replace("progress_", "");
                const prefixName = localStorage.key(i).replace("_currentTime", "");
                var mssu = moduleIdenU.split('_');
                let courseID = mssu[0];
                let unitIndex = localStorage.getItem(prefixName + "_unit_index");
                let moduleIndex = localStorage.getItem(prefixName + "_module_index");
                let isChanged: any = localStorage.getItem(prefixName + "_cTime_changed");
                if (isChanged != "true") isChanged = false;
                else isChanged = true;
                let maxTime = localStorage.getItem(prefixName + "_maxTime");
                if (maxTime == null) maxTime = "0";
                let totalVideoTime = localStorage.getItem(prefixName + "_totalVideoTime");
                if (totalVideoTime == null) totalVideoTime = "0";
                let uniqueUnitID = localStorage.getItem(prefixName + "_unique_unit_id") && !isNaN(Number(localStorage.getItem(prefixName + "_unique_unit_id"))) ? Number(localStorage.getItem(prefixName + "_unique_unit_id")) : null;
                //Leave null if null
                let uniqueModuleID = localStorage.getItem(prefixName + "_unique_module_id") && !isNaN(Number(localStorage.getItem(prefixName + "_unique_module_id"))) ? Number(localStorage.getItem(prefixName + "_unique_module_id")) : null;
                //Leave null if null

                if (isChanged == true && unitIndex != null && moduleIndex != null && courseID != null && courseID != "undefined") {
                    let temp_obj =
                    {
                        id: courseID,
                        unitIndex: unitIndex,
                        moduleIndex: moduleIndex,
                        currentTime: localStorage.getItem(localStorage.key(i)),
                        maxTime: maxTime,
                        totalVideoTime: totalVideoTime,
                        unique_unit_id: uniqueUnitID,
                        unique_module_id: uniqueModuleID,
                        changed: isChanged
                    };
                    foundData.push(temp_obj)
                    isChangedToBeRestoredAfterSuccess.push(prefixName + "_cTime_changed")
                }
            }
        }

    }

    if (foundData.length > 0) {
        var queryObject: any = {};
        queryObject.data = foundData;
        queryObject.currentCourseID = currentCourseID;
        queryObject.currentUnitIndex = currentUnitIndex;
        queryObject.currentModuleIndex = currentModuleIndex;
        queryObject.unique_unit_id = uniqueUnitID;
        queryObject.unique_module_id = uniqueModuleID;
        var jsonQuery = JSON.stringify(queryObject);

        if (jsonQuery != null && jsonQuery != "") {
            ServiceUtils.getActiveService().then(Service => {
                if (syncOrAsync == "sync") {
                    Service.setUserProgressSync(jsonQuery).then(result => {
                        isChangedToBeRestoredAfterSuccess.forEach((it) => {
                            localStorage.setItem(it, "false");
                        })
                    }).catch(error => {
                        console.log(error)
                    });
                }
                else {
                    Service.setUserProgressAsync(jsonQuery).then(result => {
                        isChangedToBeRestoredAfterSuccess.forEach((it) => {
                            localStorage.setItem(it, "false");
                        })
                    }).catch(error => {
                        console.log(error)
                    });
                }

            });
        }
    }
}

export function getParameterByName(name) {

    let url = window.location.href;

    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

export function removeParameterByName(name) {
    let url = window.location.href;

    //prefer to use l.search if you have a location/link object
    var urlparts = url.split('?');
    if (urlparts.length >= 2) {

        var prefix = encodeURIComponent(name) + '=';
        var pars = urlparts[1].split(/[&;]/g);

        //reverse iteration as may be destructive
        for (var i = pars.length; i-- > 0;) {
            //idiom for string.startsWith
            if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                pars.splice(i, 1);
            }
        }

        url = urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : "");
        return url;
    } else {
        return url;
    }
}


export function insertParameter(key, value) {
    key = encodeURI(key); value = encodeURI(value);

    var kvp = document.location.search.substr(1).split('&');

    var i = kvp.length; var x; while (i--) {
        x = kvp[i].split('=');

        if (x[0] == key) {
            x[1] = value;
            kvp[i] = x.join('=');
            break;
        }
    }

    if (i < 0) { kvp[kvp.length] = [key, value].join('='); }

    //this will reload the page, it's likely better to store this until finished
    document.location.search = kvp.join('&');
}

export function getUrlVars() {
    var vars = [], hash;
    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for (var i = 0; i < hashes.length; i++) {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
    }
    return vars;
}

var test = 0;
var prevDate = 0;

export function scrollToCurrentTextWithoutDelayCommon(shouldAnimate, calledFrom) {
    if (!(url.indexOf("/editmodule/") !== -1)) {
        //if (debug) console.log("SCROLL scrollToCurrentTextWithoutDelayCommon from " + calledFrom);

        let newtime = 0;
        let newDate = new Date().getTime();
        let difference = (Number(newDate) - Number(prevDate)) / 1000;
        prevDate = newDate;

        let isMobile = mobileAndTabletcheck();
        let moveDown = isMobile ? 0 : (screen.height / 5);

        if (document.getElementById("videoDiv") != null && difference > 2) {
            let video: any = document.getElementById("videoDiv");
            let rightDivOffset: any = jQuery('#rightDiv').offset();
            let topOffset = rightDivOffset != null ? rightDivOffset.top : 0;
            if (video != null) {
                newtime = video.currentTime;
                if (newtime != null) {
                    var textSpans = jQuery(".textSpan");
                    let diff;
                    let min = 999999;
                    let newOffset = 0;

                    for (let broj = 0; broj < textSpans.length; broj++) {
                        diff = Math.abs(parseFloat(textSpans[broj].getAttribute("data-starttime")) - newtime);
                        if (diff < min) {
                            min = diff;
                            newOffset = jQuery(textSpans[broj]).offset() != null ? jQuery(textSpans[broj]).offset().top : 0;
                        }
                    }

                    if (shouldAnimate) {
                        jQuery('#rightDiv').animate({
                            scrollTop: jQuery('#rightDiv').scrollTop() - topOffset + newOffset - 50 - moveDown
                        }, 500);
                    }

                }
                else {
                    if (shouldAnimate) {
                        let ballOffsetTop = jQuery("#ballId").offset() != null ? jQuery("#ballId").offset().top : 0;
                        jQuery('#rightDiv').animate({
                            scrollTop: jQuery('#rightDiv').scrollTop() - topOffset + ballOffsetTop - 50 - moveDown
                        }, 500);
                    }
                }
            }
        }
    }
}

export function exitFullScreen() {
    const document1: any = document;
    if (document1.fullscreenElement ||
        document1.webkitFullscreenElement ||
        document1.mozFullScreenElement) {
        if (document1.exitFullscreen) document1.exitFullscreen();
        else if (document1.mozCancelFullScreen) document1.mozCancelFullScreen();
        else if (document1.webkitCancelFullScreen) document1.webkitCancelFullScreen();
        else if (document1.msExitFullscreen) document1.msExitFullscreen();
    }
}


export function mobileAndTabletcheck() {
    var check = false;
    var myWin: any = window;

    (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true })(navigator.userAgent || navigator.vendor || myWin.opera);

    return check;
}

export function actualForceMobilePlay() {
    jQuery("#playVideoImageMobile").css("display", "none"); //Do this on time update as well
    jQuery("#playVideoImageMobileLoading").css("display", "block");
    jQuery("#playVideoImageMobileLoadingIOS").css("display", "block");

    const videoElement: any = document.getElementById("videoDiv");
    if (videoElement.paused) {
        var playPromise = videoElement.play();
        if (playPromise !== undefined) {
            playPromise.then(function () {
                if (videoElement.paused) {
                    videoElement.play();
                }
            }).catch(function (error) {
                //alert("Please load the video first");
                jQuery("#videoDiv").attr("controls", "true");
            });
        }
    } else {
        videoElement.pause();
    }
}

export function actualForceMobilePlayVideoFragment() {
    jQuery("#playVideoFragmentImageMobile").css("display", "none"); //Do this on time update as well
    jQuery("#playVideoFragmentImageMobileLoading").css("display", "block");
    jQuery("#playVideoFragmentImageMobileLoadingIOS").css("display", "block");

    const videoElement: any = document.getElementById("videoFragmentDiv");
    if (videoElement.paused) {
        var playPromise = videoElement.play();
        if (playPromise !== undefined) {
            playPromise.then(function () {
                if (videoElement.paused) {
                    videoElement.play();
                }
            }).catch(function (error) {
                //alert("Please load the video first");
                jQuery("#videoFragmentDiv").attr("controls", "true");
            });
        }
    } else {
        videoElement.pause();
    }
}

export function getAndroidVersion(): string {
    let ua = navigator.userAgent.toLowerCase();
    var match = ua.match(/android\s([0-9\.]*)/);
    return match ? match[1] : "-1";
};


export function handleParallax($container: JQuery) {
    let isMobile = mobileAndTabletcheck();
    if (!isMobile) {
        let previousPosition = { x: 0, y: 0 }
        const maxRatioDiff = 0.4;

        $container.unbind("mousemove");

        $container.bind("mousemove", function (e) {

            var x = Math.abs(Math.floor((e.pageX - previousPosition.x) / 20));
            var y = Math.abs(Math.floor((e.pageY - previousPosition.y) / 20));

            if (Math.abs(x - previousPosition.x) > maxRatioDiff * x) {
                x = Math.floor(maxRatioDiff * x);
            }
            if (Math.abs(y - previousPosition.y) > maxRatioDiff * y) {
                y = Math.floor(maxRatioDiff * y);
            }
            let temp = 5;

            if (Math.abs(x - previousPosition.x) > 1.5 || Math.abs(y - previousPosition.y) > 1.5) {
                $container.css('transition', 'background-position 0.3s');
                setTimeout(() => {
                    $container.css('transition', 'none');
                }, 300)
            }
            previousPosition.x = x;
            previousPosition.y = y;

            const backgroundPositionValue = `calc(50% - ${x}px) calc(50% - ${y}px)`;

            jQuery(this).css('background-position', backgroundPositionValue);
        });
    }

}

function listCookies() {
    var theCookies = document.cookie.split(';');
    var aString = '';
    for (var i = 1; i <= theCookies.length; i++) {
        aString += i + ' ' + theCookies[i - 1] + "\n";
    }
    return aString;
}

export function deleteJSESSIONIDcookie() {
    var domain = ".manning.com";
    var path = "/";
    document.cookie = "JSESSIONID" + "=; expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=" + domain + "; path=" + path;

    var domain = ".manning.com";
    var path = "/";
    document.cookie = "CASTGC" + "=; expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=" + domain + "; path=" + path;

    document.cookie.split(";").forEach(function (c) { document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/"); });
};



export function capitalizeFirstLetter(string) {
    if (string != null && string.length > 0) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }
    else {
        return "";
    }

}

export function isChrome() {
    var win: any = window;
    var isChromium = win.chrome,
        winNav = window.navigator,
        vendorName = winNav.vendor,
        isOpera = winNav.userAgent.indexOf("OPR") > -1,
        isIEedge = winNav.userAgent.indexOf("Edge") > -1,
        isIOSChrome = winNav.userAgent.match("CriOS");

    if (isIOSChrome) {
        return true;
    } else if (isChromium !== null && isChromium !== undefined && vendorName === "Google Inc." && isOpera == false && isIEedge == false) {
        return true;
    } else {
        return false;
    }
}

export function isSafari() {
    var is_chrome = navigator.userAgent.indexOf('Chrome') > -1;
    var is_explorer = navigator.userAgent.indexOf('MSIE') > -1;
    var is_firefox = navigator.userAgent.indexOf('Firefox') > -1;
    var is_safari = navigator.userAgent.indexOf("Safari") > -1;
    var is_opera = navigator.userAgent.toLowerCase().indexOf("op") > -1;
    if ((is_chrome) && (is_safari)) { is_safari = false; }
    if ((is_chrome) && (is_opera)) { is_chrome = false; }
    return is_safari;
}

export function isOpera() {
    var is_chrome = navigator.userAgent.indexOf('Chrome') > -1;
    var is_explorer = navigator.userAgent.indexOf('MSIE') > -1;
    var is_firefox = navigator.userAgent.indexOf('Firefox') > -1;
    var is_safari = navigator.userAgent.indexOf("Safari") > -1;
    var is_opera = navigator.userAgent.toLowerCase().indexOf("op") > -1;
    if ((is_chrome) && (is_safari)) { is_safari = false; }
    if ((is_chrome) && (is_opera)) { is_chrome = false; }
    return is_opera;
}

export function isIE11() {
    var win: any = window;
    var doc: any = document;
    return !!win.MSInputMethodContext && !!doc.documentMode;
}


export function saveToLocalStorageByUser(item_name, item_value, sha256_user) {

    if (enableLocalStorage) {
        var newObject = {
            timestamp: new Date().getTime(),
            value: item_value,
        }
    };
    if (enableLocalStorage) {
        localStorage.setItem(item_name + "_" + sha256_user, JSON.stringify(newObject));
    }

}

export function getFromLocalStorageByUser(item_name, sha256_user) {

    let result = "{}";
    if (enableLocalStorage) {
        result = localStorage.getItem(item_name + "_" + sha256_user);
    }
    return result;

}


export function ValidURL(str) {
    var pattern = new RegExp('^(https?:\/\/)?' + // protocol
        '((([a-z\d]([a-z\d-]*[a-z\d])*)\.)+[a-z]{2,}|' + // domain name
        '((\d{1,3}\.){3}\d{1,3}))' + // OR ip (v4) address
        '(\:\d+)?(\/[-a-z\d%_.~+]*)*' + // port and path
        '(\?[;&a-z\d%_.~+=-]*)?' + // query string
        '(\#[-a-z\d_]*)?$', 'i'); // fragment locater
    if (!pattern.test(str)) {
        alert("Please enter a valid URL.");
        return false;
    } else {
        return true;
    }
}

export function resizeCover(url, width, height) {
    let result = url;
    if (result != null) {
        if (result.indexOf(".manning.com/video/") !== -1) {
            result = url.replace(".manning.com/video/", ".manning.com/" + width + "/" + height + "/resize/video/")
        } else if (result.indexOf(".manning.com/liveProject/") !== -1) {
            result = url.replace(".manning.com/liveProject/", ".manning.com/" + width + "/" + height + "/resize/liveProject/")
        }
    }
    return result;
}

export function isCSSModeEnabled(language) {
    const lang = language.toLowerCase();
    const supportedCSSLanguages = ["js/html/css", "vue.js"];

    for (let i = 0; i <= supportedCSSLanguages.length; i++) {
        if (supportedCSSLanguages[i] == lang) {
            return true;
        }
    }

    return false;
}

export function isHTMLModeEnabled(language) {
    const lang = language.toLowerCase();
    const supportedCSSLanguages = ["js/html/css", "vue.js"];

    for (let i = 0; i <= supportedCSSLanguages.length; i++) {
        if (supportedCSSLanguages[i] == lang) {
            return true;
        }
    }

    return false;
}

export function getMainTabName(language) {
    const lang = language.toLowerCase();

    if (lang == "javascript" ||
        lang == "ecmascript 6" ||
        lang == "vue.js" ||
        lang == "js/html/css"
    ) {
        return "JavaScript";
    }
    else if (lang == "elm") {
        return "Elm";
    }
    else {
        return "Code";
    }
}


export function isQA() {
    var url = window.location.href;

    var showOnProd: boolean = false;
    var showOnDev: boolean = true;

    if (
        url.indexOf("localhost") !== -1
        || url.indexOf("192.168.0.") !== -1
        || url.indexOf("livevideo-ui-dev") !== -1
        || url.indexOf("lv-test-ui") !== -1
        || url.indexOf("d23vewbo0wjc8b.cloudfront.net") !== -1
        || url.indexOf("lp-test-ui") !== -1
        || url.indexOf("dlc9nze5anfoi.cloudfront.net") !== -1
        || url.indexOf("lv-test-prod-ui") !== -1
        || url.indexOf("pbc-qa.manning.com") !== -1
        || url.indexOf("liveproject-qa.manning.com") !== -1
        || (url.indexOf("pbc.manning.com") !== -1 && FORCE_LIVEPROJECT_PROD_TO_QA_BACKEND)
        || (url.indexOf("liveproject.manning.com") !== -1 && FORCE_LIVEPROJECT_PROD_TO_QA_BACKEND)
        || url.indexOf("livevideo-qa.manning.com") !== -1
    ) {
        return showOnDev;
    }
    else if (
        url.indexOf("livevideo-ui-prod") !== -1
        || url.indexOf("livevideo.manning.com") !== -1
        || (url.indexOf("pbc.manning.com") !== -1 && !FORCE_LIVEPROJECT_PROD_TO_QA_BACKEND)
        || (url.indexOf("liveproject.manning.com") !== -1 && !FORCE_LIVEPROJECT_PROD_TO_QA_BACKEND)
        || (url.indexOf("liveproject.manning.com") !== -1 && !FORCE_LIVEPROJECT_PROD_TO_QA_BACKEND)
        || url.indexOf("livevideo-tokens.manning.com") !== -1
    ) {
        return showOnProd;
    }
    else {
        alert("Possible problem detected")
        return showOnProd;
    }
}

export function getFullCourseURL(courseID, slugs, type = "course") {
    let res: any = slugs;
    let finalCourseSlug = res.course_slug;
    let newLocation = '/' + type + '/' + courseID + '/' + finalCourseSlug;
    return (newLocation)
}

export function getFullCourseURLWithRequest(courseID, insteadOfCourse?, sectionId?) {
    return new Promise((resolve, reject) => {
        ServiceUtils.getActiveService().then(Service => {
            Service.getSlugs(courseID).then(result => {
                let res: any = result;
                let finalCourseSlug = res.course_slug;
                let firstPart = insteadOfCourse || '/course/';
                let newLocation
                if (!sectionId) {
                    newLocation = firstPart + courseID + '/' + finalCourseSlug;
                } else {
                    newLocation = firstPart + courseID + '/' + sectionId + "/" + finalCourseSlug;
                }
                resolve(newLocation)
            }).catch(e => {
                let finalCourseSlug = "courseName";
                let firstPart = insteadOfCourse || '/course/';
                let newLocation = firstPart + courseID + '/' + finalCourseSlug;
                resolve(newLocation)
            })
        });
    });
}

export function getFullModuleURL(version, fullID, slugs) {

    let mss = fullID.split('_');
    var courseId = mss[0];
    var unitIndex = mss[1];
    var moduleIndex = mss[2];
    let res: any = slugs;
    let finalCourseSlug = "courseName";
    if (res.course_slug != null) {
        finalCourseSlug = res.course_slug.toLowerCase();
    }
    let finalUnitSlug = "unitName";
    let finalModuleSlug = "moduleName";

    res && res.units && res.units.map((unit) => {
        if (Number(unit.unit_index) == Number(unitIndex)) {
            if (unit.unit_slug != null) {
                finalUnitSlug = unit.unit_slug.toLowerCase();
            }
            unit.modules.map((module) => {
                if (Number(module.module_index) == Number(moduleIndex)) {
                    if (module.module_slug != null) {
                        finalModuleSlug = module.module_slug.toLowerCase();
                    }
                }
            })
        }
    });
    let newLocation = '/' + version + '/' + fullID + '/' + finalCourseSlug + '/' + finalUnitSlug + '/' + finalModuleSlug;
    return newLocation;
}

export function getFullModuleURLWithRequest(version, fullID, courseSlugs?) {
    return new Promise((resolve, reject) => {
        ServiceUtils.getActiveService().then(Service => {
            let mss = fullID.split('_');
            var courseId = mss[0];
            var unitIndex = mss[1];
            var moduleIndex = mss[2];
            if (courseSlugs) {
                let res: any = courseSlugs;
                let finalCourseSlug = "courseName";
                if (res.course_slug != null) {
                    finalCourseSlug = res.course_slug.toLowerCase();
                }
                let finalUnitSlug = "unitName";
                let finalModuleSlug = "moduleName";
                res && res.units && res.units.map((unit) => {
                    if (Number(unit.unit_index) == Number(unitIndex)) {
                        if (unit.unit_slug != null) {
                            finalUnitSlug = unit.unit_slug.toLowerCase();
                        }
                        unit.modules.map((module) => {
                            if (Number(module.module_index) == Number(moduleIndex)) {
                                if (module.module_slug != null) {
                                    finalModuleSlug = module.module_slug.toLowerCase();
                                }
                            }
                        })
                    }
                });
                let newLocation = '/' + version + '/' + fullID + '/' + finalCourseSlug + '/' + finalUnitSlug + '/' + finalModuleSlug;
                resolve(newLocation)
            } else {
                Service.getSlugs(courseId).then(result => {
                    let res: any = result;
                    let finalCourseSlug = "courseName";
                    if (res.course_slug != null) {
                        finalCourseSlug = res.course_slug.toLowerCase();
                    }
                    let finalUnitSlug = "unitName";
                    let finalModuleSlug = "moduleName";
                    res && res.units && res.units.map((unit) => {
                        if (Number(unit.unit_index) == Number(unitIndex)) {
                            if (unit.unit_slug != null) {
                                finalUnitSlug = unit.unit_slug.toLowerCase();
                            }
                            unit.modules.map((module) => {
                                if (Number(module.module_index) == Number(moduleIndex)) {
                                    if (module.module_slug != null) {
                                        finalModuleSlug = module.module_slug.toLowerCase();
                                    }
                                }
                            })
                        }
                    });
                    let newLocation = '/' + version + '/' + fullID + '/' + finalCourseSlug + '/' + finalUnitSlug + '/' + finalModuleSlug;
                    resolve(newLocation)
                }).catch(e => {
                    let finalCourseSlug = "courseName";
                    let finalUnitSlug = "unitName";
                    let finalModuleSlug = "moduleName";
                    let newLocation = '/' + version + '/' + fullID + '/' + finalCourseSlug + '/' + finalUnitSlug + '/' + finalModuleSlug;
                    resolve(newLocation)
                })
            }

        });
    });
}


export function getFullCourseURLFromAllSlugs(courseID, slugs, productURLPart = "course") {

    let found = null;
    slugs && slugs.length && slugs.map(slug => {
        if (slug.id != null && (slug.id.toString() == courseID.toString())) {
            found = slug.slug;
        }
    });
    if (found) {
        let newLocation = `/${productURLPart}/` + courseID + '/' + found;
        return newLocation;
    }
    else {
        let newLocation = `/${productURLPart}/` + courseID;
        return newLocation;
    }
}

export function detect_autoplay(acceptable_delay) {

    return new Promise((resolve, reject) => {

        resolve(false);

        /*var is_chrome = navigator.userAgent.indexOf('Chrome') > -1;
        var is_explorer = navigator.userAgent.indexOf('MSIE') > -1;
        var is_firefox = navigator.userAgent.indexOf('Firefox') > -1;
        var is_safari = navigator.userAgent.indexOf("Safari") > -1;
        var is_opera = navigator.userAgent.toLowerCase().indexOf("op") > -1;
        if ((is_chrome) && (is_safari)) { is_safari = false; }
        if ((is_chrome) && (is_opera)) { is_chrome = false; }

        let isMobile = mobileAndTabletcheck();

        if (is_safari || isMobile) {
            resolve(false);
        }

        let autoplay = false;

        var autoplay_test_content = document.createElement('video');

        //create mp4 and webm sources, 5s long
        var mp4 = document.createElement('source');
        mp4.src = "data:video/mp4;base64,AAAAFGZ0eXBNU05WAAACAE1TTlYAAAOUbW9vdgAAAGxtdmhkAAAAAM9ghv7PYIb+AAACWAAACu8AAQAAAQAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAABAAAAAAAAAAAAAAAAAABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgAAAnh0cmFrAAAAXHRraGQAAAAHz2CG/s9ghv4AAAABAAAAAAAACu8AAAAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAABAAAAAAAAAAAAAAAAAABAAAAAAFAAAAA4AAAAAAHgbWRpYQAAACBtZGhkAAAAAM9ghv7PYIb+AAALuAAANq8AAAAAAAAAIWhkbHIAAAAAbWhscnZpZGVBVlMgAAAAAAABAB4AAAABl21pbmYAAAAUdm1oZAAAAAAAAAAAAAAAAAAAACRkaW5mAAAAHGRyZWYAAAAAAAAAAQAAAAx1cmwgAAAAAQAAAVdzdGJsAAAAp3N0c2QAAAAAAAAAAQAAAJdhdmMxAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAFAAOABIAAAASAAAAAAAAAABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGP//AAAAEmNvbHJuY2xjAAEAAQABAAAAL2F2Y0MBTUAz/+EAGGdNQDOadCk/LgIgAAADACAAAAMA0eMGVAEABGjuPIAAAAAYc3R0cwAAAAAAAAABAAAADgAAA+gAAAAUc3RzcwAAAAAAAAABAAAAAQAAABxzdHNjAAAAAAAAAAEAAAABAAAADgAAAAEAAABMc3RzegAAAAAAAAAAAAAADgAAAE8AAAAOAAAADQAAAA0AAAANAAAADQAAAA0AAAANAAAADQAAAA0AAAANAAAADQAAAA4AAAAOAAAAFHN0Y28AAAAAAAAAAQAAA7AAAAA0dXVpZFVTTVQh0k/Ou4hpXPrJx0AAAAAcTVREVAABABIAAAAKVcQAAAAAAAEAAAAAAAAAqHV1aWRVU01UIdJPzruIaVz6ycdAAAAAkE1URFQABAAMAAAAC1XEAAACHAAeAAAABBXHAAEAQQBWAFMAIABNAGUAZABpAGEAAAAqAAAAASoOAAEAZABlAHQAZQBjAHQAXwBhAHUAdABvAHAAbABhAHkAAAAyAAAAA1XEAAEAMgAwADAANQBtAGUALwAwADcALwAwADYAMAA2ACAAMwA6ADUAOgAwAAABA21kYXQAAAAYZ01AM5p0KT8uAiAAAAMAIAAAAwDR4wZUAAAABGjuPIAAAAAnZYiAIAAR//eBLT+oL1eA2Nlb/edvwWZflzEVLlhlXtJvSAEGRA3ZAAAACkGaAQCyJ/8AFBAAAAAJQZoCATP/AOmBAAAACUGaAwGz/wDpgAAAAAlBmgQCM/8A6YEAAAAJQZoFArP/AOmBAAAACUGaBgMz/wDpgQAAAAlBmgcDs/8A6YEAAAAJQZoIBDP/AOmAAAAACUGaCQSz/wDpgAAAAAlBmgoFM/8A6YEAAAAJQZoLBbP/AOmAAAAACkGaDAYyJ/8AFBAAAAAKQZoNBrIv/4cMeQ==";

        var webm = document.createElement('source');
        webm.src = "data:video/webm;base64,GkXfo49CgoR3ZWJtQoeBAUKFgQEYU4BnAQAAAAAAF60RTZt0vE27jFOrhBVJqWZTrIIQA027jFOrhBZUrmtTrIIQbE27jFOrhBFNm3RTrIIXmU27jFOrhBxTu2tTrIIWs+xPvwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFUmpZuQq17GDD0JATYCjbGliZWJtbCB2MC43LjcgKyBsaWJtYXRyb3NrYSB2MC44LjFXQY9BVlNNYXRyb3NrYUZpbGVEiYRFnEAARGGIBc2Lz1QNtgBzpJCy3XZ0KNuKNZS4+fDpFxzUFlSua9iu1teBAXPFhL4G+bmDgQG5gQGIgQFVqoEAnIEAbeeBASMxT4Q/gAAAVe6BAIaFVl9WUDiqgQEj44OEE95DVSK1nIN1bmTgkbCBULqBPJqBAFSwgVBUuoE87EQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB9DtnVB4eeBAKC4obaBAAAAkAMAnQEqUAA8AABHCIWFiIWEiAICAAamYnoOC6cfJa8f5Zvda4D+/7YOf//nNefQYACgnKGWgQFNANEBAAEQEAAYABhYL/QACIhgAPuC/rOgnKGWgQKbANEBAAEQEAAYABhYL/QACIhgAPuC/rKgnKGWgQPoANEBAAEQEAAYABhYL/QACIhgAPuC/rOgnKGWgQU1ANEBAAEQEAAYABhYL/QACIhgAPuC/rOgnKGWgQaDANEBAAEQEAAYABhYL/QACIhgAPuC/rKgnKGWgQfQANEBAAEQEAAYABhYL/QACIhgAPuC/rOgnKGWgQkdANEBAAEQEBRgAGFgv9AAIiGAAPuC/rOgnKGWgQprANEBAAEQEAAYABhYL/QACIhgAPuC/rKgnKGWgQu4ANEBAAEQEAAYABhYL/QACIhgAPuC/rOgnKGWgQ0FANEBAAEQEAAYABhYL/QACIhgAPuC/rOgnKGWgQ5TANEBAAEQEAAYABhYL/QACIhgAPuC/rKgnKGWgQ+gANEBAAEQEAAYABhYL/QACIhgAPuC/rOgnKGWgRDtANEBAAEQEAAYABhYL/QACIhgAPuC/rOgnKGWgRI7ANEBAAEQEAAYABhYL/QACIhgAPuC/rIcU7trQOC7jLOBALeH94EB8YIUzLuNs4IBTbeH94EB8YIUzLuNs4ICm7eH94EB8YIUzLuNs4ID6LeH94EB8YIUzLuNs4IFNbeH94EB8YIUzLuNs4IGg7eH94EB8YIUzLuNs4IH0LeH94EB8YIUzLuNs4IJHbeH94EB8YIUzLuNs4IKa7eH94EB8YIUzLuNs4ILuLeH94EB8YIUzLuNs4INBbeH94EB8YIUzLuNs4IOU7eH94EB8YIUzLuNs4IPoLeH94EB8YIUzLuNs4IQ7beH94EB8YIUzLuNs4ISO7eH94EB8YIUzBFNm3SPTbuMU6uEH0O2dVOsghTM";

        //append sources to test video 
        autoplay_test_content.appendChild(webm);
        autoplay_test_content.appendChild(mp4);

        //set attributes -needs to be visible or IE squawks, so we move it way outside  
        autoplay_test_content.id = "base64_test_video";
        autoplay_test_content.autoplay = true;
        autoplay_test_content.style.position = "fixed";
        autoplay_test_content.style.left = "5000px";

        //add to DOM       
        document.getElementsByTagName("body")[0].appendChild(autoplay_test_content);


        var base64_test_video = document.getElementById("base64_test_video");

        //test for autoplay, 100 ms buffer   
        setTimeout(function () {
            if (!(base64_test_video as any).paused) {
                autoplay = true;
            }
            document.getElementsByTagName("body")[0].removeChild(autoplay_test_content);
            resolve(autoplay);

        }, acceptable_delay);*/
    });



}

export function makeVideosResponsive(newDescription) {
    if (newDescription != null) {
        newDescription = newDescription.replace("<iframe", `<section style="position: relative;padding-bottom: 56.25%; /* 16:9 */padding-top: 25px;
            height: 0;"><iframe id="ytplayerTEMP" class="yt-video" style="position: absolute;top: 0;left: 0;width: 100%;height: 100%;"`);
        newDescription = newDescription.replace("</iframe>", "</iframe></section>");

        newDescription = newDescription.replace("<video", `<section style="position: relative;padding-bottom: 56.25%; /* 16:9 */padding-top: 25px;
                    height: 0;"><video style="position: absolute;top: 0;left: 0;width: 100%;height: 100%;"`);
        newDescription = newDescription.replace("</video>", "</video></section>");

        return newDescription;
    }
    return newDescription;
}

export function enableYoutubeJSapi(newDescription) {
    if (newDescription) {
        const s1 = newDescription.match(/<iframe [^>]*src="[^"]*"[^>]*>/gm);
        if (s1 && s1.length) {
            const sources = s1.map(x => x.replace(/.*src="([^"]*)".*/, '$1'));
            if (sources && sources.length) {
                sources.forEach(element => {
                    if (element.indexOf("youtube.com") !== -1) {
                        let newURL = addGetParameter(addGetParameter(addGetParameter(addGetParameter(element, "enablejsapi", "1", true), "version", "3", false), "ytp-pause-overlay", "0", false), "rel", "0", false)
                        newDescription = newDescription.replace(element, newURL);
                    }
                });
            }
        }
    }
    return newDescription;
}

export function addGetParameter(url, parameterName, parameterValue, atStart/*Add param before others*/) {
    let replaceDuplicates = true;
    let urlhash;
    if (url.indexOf('#') > 0) {
        var cl = url.indexOf('#');
        urlhash = url.substring(url.indexOf('#'), url.length);
    } else {
        urlhash = '';
        cl = url.length;
    }
    let sourceUrl = url.substring(0, cl);

    var urlParts = sourceUrl.split("?");
    var newQueryString = "";

    if (urlParts.length > 1) {
        var parameters = urlParts[1].split("&");
        for (var i = 0; (i < parameters.length); i++) {
            var parameterParts = parameters[i].split("=");
            if (!(replaceDuplicates && parameterParts[0] == parameterName)) {
                if (newQueryString == "")
                    newQueryString = "?";
                else
                    newQueryString += "&";
                newQueryString += parameterParts[0] + "=" + (parameterParts[1] ? parameterParts[1] : '');
            }
        }
    }
    if (newQueryString == "")
        newQueryString = "?";

    if (atStart) {
        newQueryString = '?' + parameterName + "=" + parameterValue + (newQueryString.length > 1 ? '&' + newQueryString.substring(1) : '');
    } else {
        if (newQueryString !== "" && newQueryString != '?')
            newQueryString += "&";
        newQueryString += parameterName + "=" + (parameterValue ? parameterValue : '');
    }
    return urlParts[0] + newQueryString + urlhash;
};

export function removeGetParameter(url, parameter) {
    //prefer to use l.search if you have a location/link object
    var urlparts = url.split('?');
    if (urlparts.length >= 2) {

        var prefix = encodeURIComponent(parameter) + '=';
        var pars = urlparts[1].split(/[&;]/g);

        //reverse iteration as may be destructive
        for (var i = pars.length; i-- > 0;) {
            //idiom for string.startsWith
            if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                pars.splice(i, 1);
            }
        }

        return urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '');
    }
    return url;
}



export function doesElementContainBreak(element) {

    let result = false;
    if (jQuery(element).has("br").length > 0) {
        result = true;
    }
    var siblings = jQuery(jQuery(jQuery(jQuery(element).children()[0]).children()[0])[0]).siblings(); //Not sure if I got this right now
    if (jQuery(siblings).has("br").length > 0) {
        result = true;
    }

    /*if (jQuery(jQuery(jQuery(jQuery(element).children()[0]).children()[0])[0]).siblings().length > 0) {
        result = true;
    }*/

    return result;
}

export function doesElementContainOnlyBrElement(element) {
    let result = false;
    if (jQuery(element).has("br").length > 0) {
        result = true;
    }
    return result;
}


export function doesElementContainSiblingsAsBreak(element) {
    let result = false;
    if (jQuery(jQuery(element)[0]).siblings().length > 0) {
        result = true;
    }
    return result;
}

export function onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
}

//The reason for this is removing nbsp; from inline elements. nbsp causes inline elements not to wrap.
export function replaceNBSPInAllcuespans() {
    var regEx = /&nbsp;/gm;
    var elements = jQuery(".finalSpan").filter(function (index, ele) {
        if (regEx.test(jQuery(ele).html())) {
            jQuery(ele).html(jQuery(ele).html().replace(/&nbsp;/g, ' '));
            return true;
        }
    });
}


export function areArraysSame(array1, array2) {
    // if the other array is a falsy value, return
    if (!array1 || !array2)
        return false;

    // compare lengths - can save a lot of time 
    if (array1.length != array2.length)
        return false;

    for (var i = 0, l = array1.length; i < l; i++) {
        // Check if we have nested arrays
        if (array1[i] instanceof Array && array2[i] instanceof Array) {
            // recurse into the nested arrays
            if (!array1[i].equals(array2[i]))
                return false;
        }
        else if (array1[i] != array2[i]) {
            // Warning - two different object instances will never be equal: {x:20} != {x:20}
            return false;
        }
    }
    return true;
}

export function scrollToCurrentText(shouldAnimate, calledFrom): Promise<any> {
    return new Promise<any>((resolve, reject) => {

        //if(debug) console.log("SCROLL scrollToCurrentText (commom) from " + calledFrom);
        let isMobile = mobileAndTabletcheck();
        let moveDown = isMobile ? 0 : (screen.height / 5);
        let newtime;
        let video: any = document.getElementById("videoDiv");
        if (video) {
            newtime = video.currentTime;
        }

        if (newtime != null) {
            var textSpans = jQuery(".textSpan");
            let diff;
            let min = 999999;
            let newOffset = 0;

            for (let broj = 0; broj < textSpans.length; broj++) {
                diff = Math.abs(parseFloat(textSpans[broj].getAttribute("data-starttime")) - newtime);
                if (diff < min) {
                    min = diff;
                    newOffset = jQuery(textSpans[broj]).offset().top;
                }
            }

            if (shouldAnimate) {
                setTimeout(function () {
                    let rightDivOffsetTop: any = jQuery('#rightDiv').offset() != null ? jQuery('#rightDiv').offset().top : 0;
                    jQuery('#rightDiv').animate({
                        scrollTop: jQuery('#rightDiv').scrollTop() - rightDivOffsetTop + newOffset - 50 - moveDown
                    }, 500);
                    setTimeout(function () {
                        resolve(true);
                    }, 520);
                }, 510);
            }

        }
        else {
            if (shouldAnimate) {
                setTimeout(function () {
                    let rightDivOffsetTop: any = jQuery('#rightDiv').offset() != null ? jQuery('#rightDiv').offset().top : 0;
                    let ballOffsetTop = jQuery("#ballId").offset() != null ? jQuery("#ballId").offset().top : 0;
                    jQuery('#rightDiv').animate({
                        scrollTop: jQuery('#rightDiv').scrollTop() - rightDivOffsetTop + ballOffsetTop - 50 - moveDown
                    }, 500);
                    setTimeout(function () {
                        resolve(true);
                    }, 520);
                }, 510);
            }
        }
    });
}


export function scrollToParagraph(paragraphId): Promise<any> {
    return new Promise<any>((resolve, reject) => {
        let $spansInParagraph = jQuery('span[data-paragraphindex="' + paragraphId + '"]');
        if ($spansInParagraph && $spansInParagraph.length) {
            let isMobile = mobileAndTabletcheck();
            let moveDown = isMobile ? 0 : (screen.height / 5);
            let newOffset = jQuery($spansInParagraph[0]).offset().top;

            setTimeout(function () {
                let rightDivOffsetTop: any = jQuery('#rightDiv').offset() != null ? jQuery('#rightDiv').offset().top : 0;
                jQuery('#rightDiv').animate({
                    scrollTop: jQuery('#rightDiv').scrollTop() - rightDivOffsetTop + newOffset - 50 - moveDown
                }, 500);
                setTimeout(function () {
                    resolve(true);
                }, 520);
            }, 510);
        }
    });
}



/**
 * detect IE
 * returns version of IE or false, if browser is not Internet Explorer
 */
export function detectIE() {
    var ua = window.navigator.userAgent;

    // Test values; Uncomment to check result …

    // IE 10
    // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';

    // IE 11
    // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';

    // Edge 12 (Spartan)
    // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';

    // Edge 13
    // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

    var msie = ua.indexOf('MSIE ');
    if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }

    var trident = ua.indexOf('Trident/');
    if (trident > 0) {
        // IE 11 => return version number
        var rv = ua.indexOf('rv:');
        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }

    var edge = ua.indexOf('Edge/');
    if (edge > 0) {
        // Edge (IE 12+) => return version number
        return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
    }

    // other browser
    return false;
}


export function fixChromeMultiplevideosHack() {
    //Chrome bug with loading multiple videos
    //Workaround

    function iOSversion() {
        if (/iP(hone|od|ad)/.test(navigator.platform)) {
            // supports iOS 2.0 and later: <http://bit.ly/TJjs1V>
            var v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
            return [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || "", 10)];
        }
    }

    let ver = iOSversion();

    jQuery('video').each(function () {
        let video: HTMLVideoElement = jQuery(this).get(0) as HTMLVideoElement;
        video.pause();
        jQuery(this).empty()
        if (!ver || ver[0] >= 10) {
            jQuery(jQuery(this)[0]).attr('src', '');
            jQuery(jQuery(this)[0]).attr('preload', 'none');
            jQuery(this).prop('src', '');
        }
        jQuery(this).find('source').remove();
        jQuery(this).off();
        video.load();
        video.remove();
    });

    if (isChrome()) {
        // this hack clears up any pending socket issues. damn it chrome.
        if (window.stop !== undefined) {
            window.stop();
        } else if (document.execCommand !== undefined) {
            document.execCommand("Stop", false);
        }
    }

    if (debug) console.log("%cChrome fix (hack)", 'background: magenta; color: black');
}

export function areSameCueTracks(track1, track2) {
    if (track1 == null && track2 == null) {
        return true;
    }

    if (track1 == null || track2 == null) {
        return false;
    }

    if (track1.length != track2.length) {
        return false
    }

    for (let i1 = 0; i1 < track1.length; i1++) {
        const cue1 = track1[i1];
        const cue2 = track2[i1];
        if (cue1.text != cue2.text) {
            return false;
        }
    }
    return true;
}

export function areSameScrambledCueTracks(track1, track2) {
    if (track1 == null && track2 == null) {
        return true;
    }

    if (track1 == null || track2 == null) {
        return false;
    }

    if (track1.length != track2.length) {
        return false
    }

    for (let i1 = 0; i1 < track1.length; i1++) {
        const cue1 = track1[i1];
        const cue2 = track2[i1];
        if (cue1.text.length != cue2.text.length) {
            return false;
        }
    }
    return true;
}

export function compareArtefactOrder(a, b) {
    if (a.artifact_index < b.artifact_index) {
        return -1;
    }
    if (a.artifact_index > b.artifact_index) {
        return 1;
    }
    return 0;
}


export function firstElemChild(el) {
    if (el.firstElementChild)
        return el.firstElementChild;

    el = el.firstChild

    while (el && el.nodeType !== 1)
        el = el.nextSibling;

    return el;
}

export function compareTime(then, now) {
    var difference = (Number(now) - Number(then)) / 1000;
    return difference;
}

export function getTimingInformationForVSFromFilename(src) {

    var patt1 = /T[0-9]+.*[0-9]*_/g;
    var result = Number(src.match(patt1)[0].replace("T", "").replace("_", ""));

    return result;
}

export function disableBreaksInsideCCEditMode() {
    jQuery('.contentEditableCueSpans br').remove();
    jQuery('.contentEditableCueSpans div:empty').remove();
}

export function fixContainerSizes() {

    jQuery("#videoDiv.mobileLandscape.videoMode").css("height", window.innerHeight - 70 + "px");
    jQuery("#videoFragmentDiv.mobileLandscape.videoMode").css("height", window.innerHeight - 150 + "px");

    let newHeightFix = window.innerWidth < 900 ? window.innerHeight - jQuery("#innerContainerVideo").height() - 100 + "px" : window.innerHeight - 135 + "px";

    if (jQuery(".moduleViewTranscriptContainer").length && jQuery(".moduleViewTranscriptContainer").hasClass("mobileLandscape")) {
        jQuery("#rightDiv").css("height", window.innerHeight + "px");
        jQuery("#rightDiv #innerWrapperForTranscript").css("padding-bottom", "0px");
    } else if (jQuery(".moduleViewTranscriptContainer").length && jQuery(".moduleViewTranscriptContainer").hasClass("mobilePortrait")) {
        jQuery("#rightDiv").css("height", window.innerHeight - jQuery("#innerContainerVideo").height() - 40 + "px");
        jQuery("#rightDiv").css("innerContainerVideo", window.innerHeight - jQuery("#innerContainerVideo").height() - 40 + "px");
        jQuery("#rightDiv #innerWrapperForTranscript").css("padding-bottom", "100px");
    } else {
        jQuery("#rightDiv").css("height", newHeightFix);
        jQuery("#rightDiv #innerWrapperForTranscript").css("padding-bottom", "0px");
    }

    let newHeightFixInnerContainerVideo = window.innerHeight - 140 + "px";

    if (window.innerWidth >= 900) {
        jQuery("#innerContainerVideo").css("height", newHeightFixInnerContainerVideo);
    } else {
        jQuery("#innerContainerVideo").css("height", "auto");
    }

    //SCRAMBLED VIDEO HAS COVER AND OTHER BELOW...
    if (document.getElementById("videoFragmentWrapper") != null && document.getElementById("leftDiv") != null) {
        let innerContainerVideoHeight = document.getElementById("innerContainerVideo").clientHeight;
        let innerNotifHeight = 0;
        if (document.getElementById("innerNotif") != null) {
            innerNotifHeight = document.getElementById("innerNotif").clientHeight;
        }
    }

    let paddingForExerciseGroupContainer = "20px";
    if (jQuery(".exercise-group-container").length) {
        let widthAdjusted = Number(jQuery(".exercise-group-container").css("width").replace("px", ""))
        if (widthAdjusted > 900) {
            paddingForExerciseGroupContainer = Math.round((widthAdjusted - 900) / 2 + 55) + "px";
        }
    }

    jQuery("#videoDiv.mobilePortrait").css("height", "100%");
    jQuery("#videoFragmentDiv.mobilePortrait").css("height", "100%");

    if (window.innerWidth < 900) {
        jQuery("#productDetailsContainerWrapper").css({ "max-height": window.innerHeight / 2 + "px", "overflow": "auto" });
    } else {
        jQuery("#productDetailsContainerWrapper").css({ "max-height": "none", "oveflow": "none" });
    }

    if (window.innerWidth < 992) {
        jQuery("#headerTitles").css({ "opacity": "none" });
    } else {
        jQuery("#headerTitles").css({ "opacity": "block" });
    }

    jQuery(".CodeMirror").css("height", "auto");

    if (window.innerWidth < 900) {
        jQuery(".longScrambledNotifier").css("display", "none");
        jQuery(".shortScrambledNotifier").css("display", "block");
    } else {
        let rightDivWidth = Number((jQuery("#rightDiv").css("width") || "0px").replace("px", ""));
        if (rightDivWidth < 450) {
            jQuery(".longScrambledNotifier").css("display", "none");
            jQuery(".shortScrambledNotifier").css("display", "block");
        } else {
            jQuery(".shortScrambledNotifier").css("display", "none");
            jQuery(".longScrambledNotifier").css("display", "block");
        }
    }

    if (jQuery("#video-controls").length && jQuery('#_hj_feedback_container>div>a').length) {
        let shouldHide = false;
        if (divCollision(jQuery("#video-controls"), jQuery('#_hj_feedback_container>div>a'))) {
            shouldHide = true;
        }
        shouldHide ? hideHotjarWidget() : showHotjarWidget();
    }

    if (jQuery(".video-scrambled-overlay").length) {
        if (jQuery(".video-scrambled-overlay").width() != null && jQuery(".video-scrambled-overlay").width() < 450) {
            jQuery("#video-scrambled-overlay-description").css("display", "none");
        } else {
            jQuery("#video-scrambled-overlay-description").css("display", "block");
        }
    }

    const isMacLike = navigator.platform.match(/(Mac|iPhone|iPod|iPad)/i) ? true : false;
    if (!isMacLike) {
        jQuery(".tocUnitCaret").css("padding-right", "10px");
    }


    if (jQuery("#ballId") != null && document.getElementById("transcriptWrapperID") != null) {
        let ballTop = jQuery("#ballId").css("top");
        if (ballTop != null) {
            let ballTopNumber = Number(ballTop.replace("px", ""));
            let transcriptHeight = document.getElementById("transcriptWrapperID").clientHeight;
            if (transcriptHeight != null && !isNaN(transcriptHeight) && !isNaN(ballTopNumber)) {
                if (ballTopNumber > transcriptHeight) {
                    jQuery("#ballId").css("top", transcriptHeight)
                }
            }
        }

    }

    //Control videoDiv max-height here instead in mediaViewer
    if (jQuery("#videoDiv").length && !jQuery("#videoDiv").hasClass("mobilePortrait") && !jQuery("#videoDiv").hasClass("mobileLandscape")) {
        let maxSize = Number(window.innerHeight) - 250;
        if (window.innerWidth <= 900 && maxSize > window.innerHeight / 2) {
            maxSize = Math.round(window.innerHeight / 2) - 100;
        }
        jQuery("#videoDiv").css("max-height", maxSize + "px");
    } else {
        jQuery("#videoDiv").css("max-height", "none");
    }

    if (document.getElementById("innerWrapperForTranscript") != null) {
        let transcriptWidth = document.getElementById("innerWrapperForTranscript").offsetWidth - 80;
        jQuery(".fixed-size-image-artefact").css("max-width", transcriptWidth + "px");
    }
    if (document.getElementById("module-view-text-only-module-wrapper") != null) {
        let transcriptWidth = document.getElementById("module-view-text-only-module-wrapper").offsetWidth - 105;
        jQuery(".fixed-size-image-artefact").css("max-width", transcriptWidth + "px");
    }

    checkBigCapHeight()

    jQuery('.header').removeClass('mobile-landscape-header');
    jQuery('.header:has(.mobile-landscape-header)').addClass('mobile-landscape-header');
    jQuery('.footer').removeClass('mobile-landscape-footer');
    jQuery('.footer:has(.mobile-landscape-footer)').addClass('mobile-landscape-footer');


    if (jQuery("#tocMenuWrapper").hasClass("toc-expanded")) {
        jQuery(".module-view-wrapper").addClass("module-view-wrapper-toc-expanded");
    } else {
        jQuery(".module-view-wrapper").removeClass("module-view-wrapper-toc-expanded");
    }
    videoControlsFixes();
}

export function checkBigCapHeight() {

    let para = jQuery('p.big-cap');

    para.each(function () {
        let current = jQuery(this);
        let text = current.text();
        let copiedHTML = current.html();

        let words = text.split(' ');

        current.text(words[0]);
        var height = current.height();

        let f = 0;
        for (let i = 1; i < words.length; i++) {
            current.text(current.text() + ' ' + words[i]);

            if (current.height() > height) {
                height = current.height();
                f++;
            }
        }

        current.html(copiedHTML);
        f < 2 ? current.addClass("skip-big-cap") : current.removeClass("skip-big-cap");
    });
}



export function controlledVideoPlay(calledFrom, canVideoBePlayed) {
    jQuery(document).trigger("controlledVideoPlay");
    if (canVideoBePlayed === false) {
        if (debug) console.log("%cVideo play skipped, " + calledFrom, 'background: red; color: white')
        return;
    }
    let video: HTMLVideoElement = document.getElementById("videoDiv") as HTMLVideoElement;
    if (video != null && video instanceof HTMLVideoElement) {
        if (video.paused) {
            var isPlaying = video.currentTime > 0 && !video.paused && !video.ended
                && video.readyState > 2;

            if (!isPlaying) {
                var playPromise = video.play();
                if (playPromise !== undefined) {
                    playPromise.catch(error => {

                    });
                }
            }

            if (!(url.indexOf("/editmodule/") !== -1)) {
                scrollToCurrentTextWithoutDelayCommon(true, "common (controlledVideoPlay)");
            }
            if (debug) console.log("%cControlled video playback, " + calledFrom, 'background: green; color: white')

            let higlightElement: any = document.querySelector('input[name="highlight"]:checked');
            if (higlightElement != null) {
                jQuery(document).trigger("highlight", [higlightElement.value]);
            }
            jQuery(document).trigger("playbackSpeed", [video.playbackRate]);
        }
    }
}

export function controlledVideoPause(calledFrom) {
    jQuery(document).trigger("controlledVideoPause");
    let video: HTMLVideoElement = document.getElementById("videoDiv") as HTMLVideoElement;
    if (video != null && video instanceof HTMLVideoElement) {
        if (!video.paused) {
            video.pause();
            if (debug) console.log("%cControlled video pause, " + calledFrom, 'background: green; color: white')
        }
    }
}

export function controlledVideoCurrentTime(currentTime, calledFrom) {
    let video: HTMLVideoElement = document.getElementById("videoDiv") as HTMLVideoElement;
    if (video != null && video instanceof HTMLVideoElement) {
        if (currentTime != null && !isNaN(Number(currentTime))) {
            video.currentTime = Number(currentTime);
            if (debug) console.log("%cControlled video currentTime, " + calledFrom + " set to " + currentTime, 'background: green; color: white')
        } else {
            if (debug) console.log(currentTime + " " + calledFrom)
        }
    }
}

export function getTopFromTextSpanTimes() {
    const ball = document.getElementById("ballId");
    let video = null;
    let newOffsetFromTextSpanStartTimes = 0;
    if (document.getElementById("videoDiv") != null && document.getElementById("videoDiv") instanceof HTMLVideoElement) {
        video = document.getElementById("videoDiv");

        let newtime = video.currentTime || 0;
        let diff;
        let min = 999999;

        var textSpans = jQuery(".textSpan");
        for (let broj = 0; broj < textSpans.length; broj++) {
            diff = Math.abs(parseFloat(textSpans[broj].getAttribute("data-starttime")) - newtime);
            if (diff < min) {
                min = diff;
                newOffsetFromTextSpanStartTimes = jQuery(textSpans[broj]).offset() != null ? jQuery(textSpans[broj]).offset().top : 0;
            }
        }
    }
    return newOffsetFromTextSpanStartTimes;
}

export function updateBallPosition(isVideoVisible) {

    const ball = document.getElementById("ballId");
    let topValue = 0;

    //Update ball position
    let currentSpan;
    let allCurrentSpans = document.getElementsByClassName("currentTextClass");
    if (allCurrentSpans && allCurrentSpans.length) {
        currentSpan = allCurrentSpans[0];
    }
    if (currentSpan != null) {

        let ClientRect = currentSpan.getClientRects();
        let topOffset: number = 0;
        for (let i = 0; i < ClientRect.length; i++) {
            topOffset = topOffset + ClientRect[i].top;
        }
        topOffset = topOffset / ClientRect.length;

        const line = document.getElementById("line");
        if (line != null) {
            let ClientRectOfLine = line.getClientRects();
            let CTop = ClientRectOfLine[0] != null ? ClientRectOfLine[0].top : 0;
            let CLeft = ClientRectOfLine[0] != null ? ClientRectOfLine[0].left : 0;
            let CRight = ClientRectOfLine[0] != null ? ClientRectOfLine[0].right : 0;
            let topOfTheLine = CTop;
            let center = (CLeft + CRight) / 2;
            let newTopValue = topOffset - topOfTheLine;

            //Dont allow this to be all the way down
            let newTopValueString = newTopValue + "px";
            topValue = newTopValue;
            let video: any = document.getElementById("videoDiv");
            let newOffsetFromTextSpanStartTimes = getTopFromTextSpanTimes();

            if (video.paused) {
                jQuery(ball).css("top", newOffsetFromTextSpanStartTimes);
            }
            const currentTimeInSecondsTemp = video != null ? video.currentTime : 0;

            if (currentTimeInSecondsTemp != 0) {
                if (isVideoVisible) {
                    jQuery(ball).css("top", newTopValueString);
                } else {
                    jQuery(ball).css("top", newOffsetFromTextSpanStartTimes + "px");
                    topValue = newOffsetFromTextSpanStartTimes;
                }
            } else {
                jQuery(ball).css("top", newTopValueString);
            }
        }
    } else {
        //Was causing jumps... carefull
        /*let video: any = document.getElementById("videoDiv");
        let newOffsetFromTextSpanStartTimes = getTopFromTextSpanTimes();
        jQuery(ball).css("top", newOffsetFromTextSpanStartTimes + "px");
        topValue = newOffsetFromTextSpanStartTimes;*/
    }
    return topValue;
}

export function hideMobileKeyboard() {
    let isMobile = mobileAndTabletcheck();
    if (isMobile) {
        var field = document.createElement('input');
        field.setAttribute('type', 'text');
        document.body.appendChild(field);

        setTimeout(function () {
            field.focus();
            setTimeout(function () {
                field.setAttribute('style', 'display:none;');
            }, 50);
        }, 50);
    }
}

export function detectHorizontalWiggle() {
    var docWidth = document.documentElement.offsetWidth;

    [].forEach.call(
        document.querySelectorAll('*'),
        function (el) {
            if (el.offsetWidth > docWidth) {
                console.log(el);
            }
        }
    );
}

export function returnBadWords() {
    return `abbo|abo|abortion|abuse|addict|addicts|adult|africa|african|alla|allah|alligatorbait|amateur|american|anal|analannie|analsex|angie|angry|anus|arab|arabs|areola|argie|aroused|arse|arsehole|asian|ass|assassin|assassinate|assassination|assault|assbagger|assblaster|assclown|asscowboy|asses|assfuck|assfucker|asshat|asshole|assholes|asshore|assjockey|asskiss|asskisser|assklown|asslick|asslicker|asslover|assman|assmonkey|assmunch|assmuncher|asspacker|asspirate|asspuppies|assranger|asswhore|asswipe|athletesfoot|attack|australian|babe|babies|backdoor|backdoorman|backseat|badfuck|balllicker|balls|ballsack|banging|baptist|barelylegal|barf|barface|barfface|bast|bastard|bazongas|bazooms|beaner|beast|beastality|beastial|beastiality|beatoff|beat-off|beatyourmeat|beaver|bestial|bestiality|bi|biatch|bible|bicurious|bigass|bigbastard|bigbutt|bigger|bisexual|bi-sexual|bitch|bitcher|bitches|bitchez|bitchin|bitching|bitchslap|bitchy|biteme|black|blackman|blackout|blacks|blind|blow|blowjob|boang|bogan|bohunk|bollick|bollock|bomb|bombers|bombing|bombs|bomd|bondage|boner|bong|boob|boobies|boobs|booby|boody|boom|boong|boonga|boonie|booty|bootycall|bountybar|bra|brea5t|breast|breastjob|breastlover|breastman|brothel|bugger|buggered|buggery|bullcrap|bulldike|bulldyke|bullshit|bumblefuck|bumfuck|bunga|bunghole|buried|burn|butchbabes|butchdike|butchdyke|butt|buttbang|butt-bang|buttface|buttfuck|butt-fuck|buttfucker|butt-fucker|buttfuckers|butt-fuckers|butthead|buttman|buttmunch|buttmuncher|buttpirate|buttplug|buttstain|byatch|cacker|cameljockey|cameltoe|canadian|cancer|carpetmuncher|carruth|catholic|catholics|cemetery|chav|cherrypopper|chickslick|children's|chin|chinaman|chinamen|chinese|chink|chinky|choad|chode|christ|christian|church|cigarette|cigs|clamdigger|clamdiver|clit|clitoris|clogwog|cocaine|cock|cockblock|cockblocker|cockcowboy|cockfight|cockhead|cockknob|cocklicker|cocklover|cocknob|cockqueen|cockrider|cocksman|cocksmith|cocksmoker|cocksucer|cocksuck|cocksucked|cocksucker|cocksucking|cocktail|cocktease|cocky|cohee|coitus|commie|communist|condom|conservative|conspiracy|coolie|cooly|coon|coondog|copulate|cornhole|corruption|cra5h|crabs|crack|crackpipe|crackwhore|crack-whore|crap|crapola|crapper|crappy|crash|creamy|crime|crimes|criminal|criminals|crotch|crotchjockey|crotchmonkey|crotchrot|cum|cumbubble|cumfest|cumjockey|cumm|cummer|cumming|cumquat|cumqueen|cumshot|cunilingus|cunillingus|cunn|cunnilingus|cunntt|cunt|cunteyed|cuntfuck|cuntfucker|cuntlick|cuntlicker|cuntlicking|cuntsucker|cybersex|cyberslimer|dago|dahmer|dammit|damn|damnation|damnit|darkie|darky|datnigga|dead|deapthroat|death|deepthroat|defecate|dego|demon|deth|devil|devilworshipper|dick|dickbrain|dickforbrains|dickhead|dickless|dicklick|dicklicker|dickman|dickwad|dickweed|diddle|die|died|dies|dike|dildo|dingleberry|dink|dipshit|dipstick|dirty|disease|diseases|disturbed|dive|dix|dixiedike|dixiedyke|doggiestyle|doggystyle|dong|doodoo|doo-doo|doom|dope|dragqueen|dragqween|dripdick|drug|drunk|drunken|dumb|dumbass|dumbbitch|dumbfuck|dyefly|dyke|easyslut|eatballs|eatme|eatpussy|ecstacy|ejaculate|ejaculated|ejaculating|ejaculation|enema|enemy|erect|erection|ero|escort|ethiopian|ethnic|european|evl|excrement|execute|executed|execution|executioner|explosion|facefucker|faeces|fag|fagging|faggot|fagot|failed|fairies|fairy|faith|fannyfucker|fart|farted|farting|farty|fastfuck|fat|fatah|fatass|fatfuck|fatfucker|fatso|fckcum|fear|feces|felatio|felch|felcher|felching|fellatio|feltch|feltcher|feltching|fetish|fight|filipina|filipino|fingerfood|fingerfuck|fingerfucked|fingerfucker|fingerfuckers|fingerfucking|fire|firing|fister|fistfuck|fistfucked|fistfucker|fistfucking|fisting|flange|flasher|flatulence|floo|flydie|flydye|fok|fondle|footaction|footfuck|footfucker|footlicker|footstar|fore|foreskin|forni|fornicate|foursome|fourtwenty|fraud|freakfuck|freakyfucker|freefuck|fu|fubar|fuc|fucck|fuck|fucka|fuckable|fuckbag|fuckbuddy|fucked|fuckedup|fucker|fuckers|fuckface|fuckfest|fuckfreak|fuckfriend|fuckhead|fuckher|fuckin|fuckina|fucking|fuckingbitch|fuckinnuts|fuckinright|fuckit|fuckknob|fuckme|fuckmehard|fuckmonkey|fuckoff|fuckpig|fucks|fucktard|fuckwhore|fuckyou|fudgepacker|fugly|fuk|fuks|funeral|funfuck|fungus|fuuck|gangbang|gangbanged|gangbanger|gangsta|gatorbait|gay|gaymuthafuckinwhore|gaysex|geez|geezer|geni|genital|german|getiton|gin|ginzo|gipp|girls|givehead|glazeddonut|gob|god|godammit|goddamit|goddammit|goddamn|goddamned|goddamnes|goddamnit|goddamnmuthafucker|goldenshower|gonorrehea|gonzagas|gook|gotohell|goy|goyim|greaseball|gringo|groe|gross|grostulation|gubba|gummer|gun|gyp|gypo|gypp|gyppie|gyppo|gyppy|hamas|handjob|hapa|harder|hardon|harem|headfuck|headlights|hebe|heeb|hell|henhouse|heroin|herpes|heterosexual|hijack|hijacker|hijacking|hillbillies|hindoo|hiscock|hitler|hitlerism|hitlerist|hiv|ho|hobo|hodgie|hoes|hole|holestuffer|homicide|homo|homobangers|homosexual|honger|honk|honkers|honkey|honky|hook|hooker|hookers|hooters|hore|hork|horn|horney|horniest|horny|horseshit|hosejob|hoser|hostage|hotdamn|hotpussy|hottotrot|hummer|husky|hussy|hustler|hymen|hymie|iblowu|idiot|ikey|illegal|incest|insest|intercourse|interracial|intheass|inthebuff|israel|israeli|israel's|italiano|itch|jackass|jackoff|jackshit|jacktheripper|jade|jap|japanese|japcrap|jebus|jeez|jerkoff|jesus|jesuschrist|jew|jewish|jiga|jigaboo|jigg|jigga|jiggabo|jigger|jiggy|jihad|jijjiboo|jimfish|jism|jiz|jizim|jizjuice|jizm|jizz|jizzim|jizzum|joint|juggalo|jugs|junglebunny|kaffer|kaffir|kaffre|kafir|kanake|kid|kigger|kike|kill|killed|killer|killing|kills|kink|kinky|kissass|kkk|knife|knockers|kock|kondum|koon|kotex|krap|krappy|kraut|kum|kumbubble|kumbullbe|kummer|kumming|kumquat|kums|kunilingus|kunnilingus|kunt|kyke|lactate|laid|lapdance|latin|lesbain|lesbayn|lesbian|lesbin|lesbo|lez|lezbe|lezbefriends|lezbo|lezz|lezzo|liberal|libido|licker|lickme|lies|limey|limpdick|limy|lingerie|liquor|livesex|loadedgun|lolita|looser|loser|lotion|lovebone|lovegoo|lovegun|lovejuice|lovemuscle|lovepistol|loverocket|lowlife|lsd|lubejob|lucifer|luckycammeltoe|lugan|lynch|macaca|mad|mafia|magicwand|mams|manhater|manpaste|marijuana|mastabate|mastabater|masterbate|masterblaster|mastrabator|masturbate|masturbating|mattressprincess|meatbeatter|meatrack|meth|mexican|mgger|mggor|mickeyfinn|mideast|milf|minority|mockey|mockie|mocky|mofo|moky|moles|molest|molestation|molester|molestor|moneyshot|mooncricket|mormon|moron|moslem|mosshead|mothafuck|mothafucka|mothafuckaz|mothafucked|mothafucker|mothafuckin|mothafucking|mothafuckings|motherfuck|motherfucked|motherfucker|motherfuckin|motherfucking|motherfuckings|motherlovebone|muff|muffdive|muffdiver|muffindiver|mufflikcer|mulatto|muncher|munt|murder|murderer|muslim|naked|narcotic|nasty|nastybitch|nastyho|nastyslut|nastywhore|nazi|necro|negro|negroes|negroid|negro's|nig|niger|nigerian|nigerians|nigg|nigga|niggah|niggaracci|niggard|niggarded|niggarding|niggardliness|niggardliness's|niggardly|niggards|niggard's|niggaz|nigger|niggerhead|niggerhole|niggers|nigger's|niggle|niggled|niggles|niggling|nigglings|niggor|niggur|niglet|nignog|nigr|nigra|nigre|nip|nipple|nipplering|nittit|nlgger|nlggor|nofuckingway|nook|nookey|nookie|noonan|nooner|nude|nudger|nuke|nutfucker|nymph|ontherag|oral|orga|orgasim|orgasm|orgies|orgy|osama|paki|palesimian|palestinian|pansies|pansy|panti|panties|payo|pearlnecklace|peck|pecker|peckerwood|pee|peehole|pee-pee|peepshow|peepshpw|pendy|penetration|peni5|penile|penis|penises|penthouse|period|perv|phonesex|phuk|phuked|phuking|phukked|phukking|phungky|phuq|pi55|picaninny|piccaninny|pickaninny|piker|pikey|piky|pimp|pimped|pimper|pimpjuic|pimpjuice|pimpsimp|pindick|piss|pissed|pisser|pisses|pisshead|pissin|pissing|pissoff|pistol|pixie|pixy|playboy|playgirl|pocha|pocho|pocketpool|pohm|polack|pom|pommie|pommy|poo|poon|poontang|poop|pooper|pooperscooper|pooping|poorwhitetrash|popimp|porchmonkey|porn|pornflick|pornking|porno|pornography|pornprincess|pot|poverty|premature|pric|prick|prickhead|primetime|propaganda|pros|prostitute|protestant|pu55i|pu55y|pube|pubic|pubiclice|pud|pudboy|pudd|puddboy|puke|puntang|purinapricness|puss|pussie|pussies|pussy|pussycat|pussyeater|pussyfucker|pussylicker|pussylips|pussylover|pussypounder|pusy|quashie|queef|queer|quickie|quim|ra8s|rabbi|racial|racist|radical|radicals|raghead|randy|rape|raped|raper|rapist|rearend|rearentry|rectum|redlight|redneck|reefer|reestie|refugee|reject|remains|rentafuck|republican|rere|retard|retarded|ribbed|rigger|rimjob|rimming|roach|robber|roundeye|rump|russki|russkie|sadis|sadom|samckdaddy|sandm|sandnigger|satan|scag|scallywag|scat|schlong|screw|screwyou|scrotum|scum|semen|seppo|servant|sex|sexed|sexfarm|sexhound|sexhouse|sexing|sexkitten|sexpot|sexslave|sextogo|sextoy|sextoys|sexual|sexually|sexwhore|sexy|sexymoma|sexy-slim|shag|shaggin|shagging|shat|shav|shawtypimp|sheeney|shhit|shinola|shit|shitcan|shitdick|shite|shiteater|shited|shitface|shitfaced|shitfit|shitforbrains|shitfuck|shitfucker|shitfull|shithapens|shithappens|shithead|shithouse|shiting|shitlist|shitola|shitoutofluck|shits|shitstain|shitted|shitter|shitting|shitty|shoot|shooting|shortfuck|showtime|sick|sissy|sixsixsix|sixtynine|sixtyniner|skank|skankbitch|skankfuck|skankwhore|skanky|skankybitch|skankywhore|skinflute|skum|skumbag|slant|slanteye|slapper|slaughter|slav|slave|slavedriver|sleezebag|sleezeball|slideitin|slime|slimeball|slimebucket|slopehead|slopey|slopy|slut|sluts|slutt|slutting|slutty|slutwear|slutwhore|smack|smackthemonkey|smut|snatch|snatchpatch|snigger|sniggered|sniggering|sniggers|snigger's|sniper|snot|snowback|snownigger|sob|sodom|sodomise|sodomite|sodomize|sodomy|sonofabitch|sonofbitch|sooty|sos|soviet|spaghettibender|spaghettinigger|spank|spankthemonkey|sperm|spermacide|spermbag|spermhearder|spermherder|spic|spick|spig|spigotty|spik|spit|spitter|splittail|spooge|spreadeagle|spunk|spunky|squaw|stagg|stiffy|strapon|stringer|stripclub|stroke|stroking|stupid|stupidfuck|stupidfucker|suck|suckdick|sucker|suckme|suckmyass|suckmydick|suckmytit|suckoff|suicide|swallow|swallower|swalow|swastika|sweetness|syphilis|taboo|taff|tampon|tang|tantra|tarbaby|tard|teat|terror|terrorist|teste|testicle|testicles|thicklips|thirdeye|thirdleg|threesome|threeway|timbernigger|tinkle|tit|titbitnipply|titfuck|titfucker|titfuckin|titjob|titlicker|titlover|tits|tittie|titties|titty|tnt|toilet|tongethruster|tongue|tonguethrust|tonguetramp|tortur|torture|tosser|towelhead|trailertrash|tramp|trannie|tranny|transexual|transsexual|transvestite|triplex|trisexual|trojan|trots|tuckahoe|tunneloflove|turd|turnon|twat|twink|twinkie|twobitwhore|unfuckable|upskirt|uptheass|upthebutt|urinary|urinate|urine|usama|uterus|vagina|vaginal|vatican|vibr|vibrater|vibrator|vietcong|violence|virgin|virginbreaker|vomit|vulva|wab|wank|wanker|wanking|waysted|weapon|weenie|weewee|welcher|welfare|wetb|wetback|wetspot|whacker|whash|whigger|whiskey|whiskeydick|whiskydick|whit|whitenigger|whites|whitetrash|whitey|whiz|whop|whore|whorefucker|whorehouse|wigger|willie|williewanker|willy|wog|wop|wtf|wuss|wuzzie|xtc|xxx|yankee|yellowman|zigabo|zipperhead`;
}

export function videoError(e) {
    if (e.target != null) {
        var target: any = e.target;
        if (target.error != null) {

            if (target.error.code != null) {
                if (target.error.code == 1) {
                    console.log("Video error - fetching process aborted by user");
                }
                else if (target.error.code == 2) {
                    console.log("Video error - error occurred when downloading");
                }
                else if (target.error.code == 3) {
                    console.log("Video error - error occurred when decoding video");
                }
                else if (target.error.code == 4) {
                    console.log("Video error - audio/video not supported!");
                }
                else {
                    console.log("Video error - unknown error");
                }
            }
            else {
                console.log("Video error - unknown error");
            }
        }
    }
    console.log("Error while loading the video", e, e.target);
}


export function videoControlsFixes() {
    if (jQuery(".ProgressBar-seek").width() < 400) {
        jQuery(".videoControlsHideIfTooSmall").addClass("videoControlsForceHide");
        jQuery(".videoControlsShowIfTooSmall").addClass("videoControlsForceShow");
    } else {
        jQuery(".videoControlsHideIfTooSmall").removeClass("videoControlsForceHide");
        jQuery(".videoControlsShowIfTooSmall").removeClass("videoControlsForceShow");
    }

    if (jQuery(".ProgressBar-seek").width() < 250) {
        jQuery(".videoControlsHideIfTooSmall250").addClass("videoControlsForceHide");
        jQuery(".videoControlsShowIfTooSmall250").addClass("videoControlsForceShow");
    } else {
        jQuery(".videoControlsHideIfTooSmall250").removeClass("videoControlsForceHide");
        jQuery(".videoControlsShowIfTooSmall250").removeClass("videoControlsForceShow");
    }
}

declare var ga;
declare var fbq;


function sendGaEvent(send, event, eventCategory, eventAction?, eventLabel?, eventValue?) {
    let isGTM = true;
    if (isGTM) {
        let legacyEvent: any = {
            category: `${eventCategory}̨`,
        }
        if (eventAction) {
            legacyEvent = {
                ...legacyEvent,
                action: `${eventAction}̨`,
            }
        }
        if (eventLabel) {
            legacyEvent = {
                ...legacyEvent,
                label: `${eventLabel}̨`,
            }
        }
        if (eventValue) {
            legacyEvent = {
                ...legacyEvent,
                value: `${eventValue}̨`,
            }
        }

        const preparedObject = {
            event: 'legacyEvent',
            legacyEvent: [legacyEvent]
        };
        pushEventToDataLayer(preparedObject);
    } else {
        ga(send, event, eventCategory, eventAction, eventLabel, eventValue);
    }
}

export function gaTrackingBinding($) {
    if ((window as any).wasGABinded) {
        return;
    }

    (window as any).wasGABinded = true;

    let $document = $(document);
    let displayEventsInConsole = isQA();

    $document.on("pauseOnArtefact", (e, type, value, moduleIden) => {
        if (displayEventsInConsole) console.log("%cuserSettings", 'background: #FF0000; color: white', "pauseOnArtefact", type + " " + value);
        sendGaEvent('send', 'event', "userSettings", "pauseOnArtefact", type + " " + value);
    })

    $document.on("autoPlay", (e, type) => {
        if (displayEventsInConsole) console.log("%cuserSettings", 'background: #FF0000; color: white', "autoPlay", type);
        sendGaEvent('send', 'event', "userSettings", "autoPlay", type);
    })

    $document.on("autoContinue", (e, type) => {
        if (displayEventsInConsole) console.log("%cuserSettings", 'background: #FF0000; color: white', "autoContinue", type);
        sendGaEvent('send', 'event', "userSettings", "autoContinue", type);
    })

    $document.on("highlight", (e, type) => {
        if (displayEventsInConsole) console.log("%cuserSettings (onPlay)", 'background: #FF0000; color: white', "highlight (when clicked play)", type);
        sendGaEvent('send', 'event', "userSettings (onPlay)", "highlight (when clicked play)", type);
    })

    $document.on("playbackSpeed", (e, type) => {
        if (displayEventsInConsole) console.log("%cuserSettings (onPlay)", 'background: #FF0000; color: white', "speed (when clicked play)", type);
        sendGaEvent('send', 'event', "userSettings (onPlay)", "speed (when clicked play)", type);
    })

    $document.on("searchOpen", (e) => {
        if (displayEventsInConsole) console.log("%csearch)", 'background: #FF0000; color: white', "search", "opened");
        sendGaEvent('send', 'event', "search", "opened");
    })


    $document.on("searchSuggestion", (e, type, data) => {
        setTimeout(() => {
            if (displayEventsInConsole) console.log("%csearch", 'background: #FF0000; color: white', "search", data);
            sendGaEvent('send', 'event', 'searchSuggestion', type, data);
        }, 50);
    });


    $document.on("downloadVideo", (e) => {
        if (displayEventsInConsole) console.log("%cdownloadVideo", 'background: #FF0000; color: white', "downloadVideo");
        sendGaEvent('send', 'event', "downloadVideo");
    })

    $document.on("goFullscreen", (e) => {
        if (displayEventsInConsole) console.log("%cgoFullscreen)", 'background: #FF0000; color: white', "goFullscreen");
        sendGaEvent('send', 'event', "goFullscreen");
    })

    $document.on("startTour", (e) => {
        if (displayEventsInConsole) console.log("%cstartTour", 'background: #FF0000; color: white', "startTour");
        sendGaEvent('send', 'event', "startTour");
    })

    $document.on("mainPlayButton", (e) => {
        if (displayEventsInConsole) console.log("%cvideo", 'background: #FF0000; color: white', "navigation", "mainPlayButton");
        sendGaEvent('send', 'event', "video", "navigation", "mainPlayButton");
    })
    $document.on("jumpToFromTranscript", (e) => {
        if (displayEventsInConsole) console.log("%cvideo", 'background: #FF0000; color: white', "navigation", "jumpToFromTranscript");
        sendGaEvent('send', 'event', "video", "navigation", "jumpToFromTranscript");
    })
    $document.on("jumpFromProgressBar", (e) => {
        if (displayEventsInConsole) console.log("%cvideo", 'background: #FF0000; color: white', "navigation", "jumpFromProgressBar");
        sendGaEvent('send', 'event', "video", "navigation", "jumpFromProgressBar");
    })
    $document.on("playbackTrackBall", (e) => {
        if (displayEventsInConsole) console.log("%cvideo", 'background: #FF0000; color: white', "navigation", "playbackTrackBall");
        sendGaEvent('send', 'event', "video", "navigation", "playbackTrackBall");
    })
    $document.on("keyboardPlaybackControl", (e, type) => {
        if (displayEventsInConsole) console.log("%cvideo", 'background: #FF0000; color: white', "navigation", "keyboardPlaybackControl " + type);
        sendGaEvent('send', 'event', "video", "navigation", "keyboardPlaybackControl " + type);
    })

    $document.on("transcript", (e, type) => {
        if (displayEventsInConsole) console.log("%ctranscript", 'background: #FF0000; color: white', "transcript", type);
        sendGaEvent('send', 'event', "transcript", type);
    })

    $document.on("getIt", (e, moduleIden, quizId) => {
        if (displayEventsInConsole) console.log("%cartefacts", 'background: #FF0000; color: white', "getIt", moduleIden + " " + quizId);
        sendGaEvent('send', 'event', "artefacts", "getIt", moduleIden + " " + quizId);
    })

    $document.on("tryIt", (e, moduleIden, tryItId) => {
        if (displayEventsInConsole) console.log("%cartefacts", 'background: #FF0000; color: white', "tryIt", moduleIden + " " + tryItId);
        sendGaEvent('send', 'event', "artefacts", "tryIt", moduleIden + " " + tryItId);
    })


    $document.on("moduleOpened", (e, info, modulIden) => {
        if (displayEventsInConsole) console.log("%cmoduleData", 'background: #FF0000; color: white', "moduleOpened", info);
        sendGaEvent('send', 'event', "moduleData", "moduleOpened", info);
    })
    $document.on("moduleVisibility", (e, info, modulIden) => {
        if (displayEventsInConsole) console.log("%cmoduleData", 'background: #FF0000; color: white', "moduleVisibility", info);
        sendGaEvent('send', 'event', "moduleData", "moduleVisibility", info);
    })
    $document.on("isMEAP", (e, info, modulIden) => {
        if (displayEventsInConsole) console.log("%cisMEAP", 'background: #FF0000; color: white', "isMEAP", info);
        sendGaEvent('send', 'event', "moduleData", "isMEAP", info);
    })

    $document.on("moduleType", (e, info, moduleType) => {
        if (displayEventsInConsole) console.log("%cmoduleType", 'background: #FF0000; color: white', "moduleType", info);
        sendGaEvent('send', 'event', "moduleData", "moduleType", info);
    })



    $document.on("unlockParagraph", (e, info) => {
        if (displayEventsInConsole) console.log("%cmicrotransactions", 'background: #FF0000; color: white', "unlock paragraph", info);
        sendGaEvent('send', 'event', "microtransactions", "unlockParagraph", info);
    })
    $document.on("unlockModule", (e, info) => {
        if (displayEventsInConsole) console.log("%cmicrotransactions", 'background: #FF0000; color: white', "unlock module", info);
        sendGaEvent('send', 'event', "microtransactions", "unlockModule", info);
    })
    $document.on("unlockUnit", (e, info) => {
        if (displayEventsInConsole) console.log("%cmicrotransactions", 'background: #FF0000; color: white', "unlock unit", info);
        sendGaEvent('send', 'event', "microtransactions", "unlockUnit", info);
    })
    $document.on("cashout", (e?) => {
        if (displayEventsInConsole) console.log("%cmicrotransactions", 'background: #FF0000; color: white', "cashout");
        sendGaEvent('send', 'event', "microtransactionModalActions", "cashout");
    })
    $document.on("tokenLedger", (e) => {
        if (displayEventsInConsole) console.log("%cmicrotransactions", 'background: #FF0000; color: white', "tokenLedger");
        sendGaEvent('send', 'event', "microtransactionModalActions", "tokenLedger");
    })
    $document.on("tokenModalOpened", (e) => {
        if (displayEventsInConsole) console.log("%cmicrotransactions", 'background: #FF0000; color: white', "tokenModalOpened");
        sendGaEvent('send', 'event', "microtransactionModalActions", "tokenModalOpened");
    })
    $document.on("getMoreTokens", (e) => {
        if (displayEventsInConsole) console.log("%cmicrotransactions", 'background: #FF0000; color: white', "getMoreTokens");
        sendGaEvent('send', 'event', "microtransactionModalActions", "getMoreTokens");
    })

    $document.on("downloadCourse", (e, info) => {
        if (displayEventsInConsole) console.log("%cdownloadCourse", 'background: #FF0000; color: white', "downloadCourse");
        sendGaEvent('send', 'event', "downloadCourse", info);
    })

    $document.on("manningURLClicked", (e, type) => {
        if (displayEventsInConsole) console.log("%cManning URL clicked", 'background: #FF0000; color: white', type);
        sendGaEvent('send', 'event', "Manning URL clicked", type);
    })

    $document.on("youtubeVideoPlay", (e, type, data) => {
        if (displayEventsInConsole) console.log("%cYoutube video played", 'background: #FF0000; color: white', type, data);
        sendGaEvent('send', 'event', "Youtube Video Play", type, data);
    })

    $document.on("cargoBay", (e, type) => {
        if (displayEventsInConsole) console.log("%cAdmin tools - cargo bay", 'background: #FF0000; color: white', type);
        sendGaEvent('send', 'event', "Admin tools", "cargo bay", type);
    })
    $document.on("invalidateCache", (e, type) => {
        if (displayEventsInConsole) console.log("%cAdmin tools - invaidate cache", 'background: #FF0000; color: white', type);
        sendGaEvent('send', 'event', "Admin tools", "invalidate cache", type);
    })

    $document.on("discussionMenuOpened", (e, type) => {
        if (displayEventsInConsole) console.log("%cDiscussions opened", 'background: #FF0000; color: white');
        sendGaEvent('send', 'event', "Social events", "Open");
    })

    $document.on("liveVideoEnroled", (e, type) => {
        if (displayEventsInConsole) console.log("%cliveVideo enroled", 'background: #FF0000; color: white');
        sendGaEvent('send', 'event', "Enrol", "liveVideo", type);
    })

    $document.on("signin", (e, type) => {
        if (displayEventsInConsole) console.log("%csignin", 'background: #FF0000; color: white');
        sendGaEvent('send', 'event', "signin", PlatformUtils.getAppName());
    })

    $document.on("CompleteRegistration", (e, type) => {
        if (displayEventsInConsole) console.log("%cCompleteRegistration", 'background: #FF0000; color: white');
        sendGaEvent('send', 'event', "CompleteRegistration", type);
        if (typeof fbq !== 'undefined') fbq('track', 'CompleteRegistration');
    })

    //liveProject

    $document.on("livePLatestCoursesClicked", (e, type) => {
        if (displayEventsInConsole) console.log("%cLP: latest projects item clicked", 'background: #FF0000; color: white');
        sendGaEvent('send', 'event', "latest projects item clicked", type);
    })
    $document.on("changeProfileImage", (e, type) => {
        if (displayEventsInConsole) console.log("%cAvatar profile clicked", 'background: #FF0000; color: white');
        sendGaEvent('send', 'event', "Profile", "LP: avatar profile in header clicked");
    })
    $document.on("geocodeCalled", (e, type) => {
        if (displayEventsInConsole) console.log("%cGeocode api called", 'background: #FF0000; color: white');
        sendGaEvent('send', 'event', "Profile", "Geocode api called", type);
    })
    $document.on("SkillPyramidSmallChanges", (e, type) => {
        if (displayEventsInConsole) console.log("%cSkill pyramid changes", 'background: #FF0000; color: white');
        sendGaEvent('send', 'event', "Profile", "Skill pyramid shanges");
    })
    $document.on("WorkHoursSmallChanges", (e, type) => {
        if (displayEventsInConsole) console.log("%cWork hours changes", 'background: #FF0000; color: white');
        sendGaEvent('send', 'event', "Profile", "Work hours changes");
    })
    $document.on("profileSaved", (e, type) => {
        if (displayEventsInConsole) console.log("%cProfile saved", 'background: #FF0000; color: white');
        sendGaEvent('send', 'event', "Profile", "Profile saved");
    })
    $document.on("profileSharePreferencesChanged", (e, type) => {
        if (displayEventsInConsole) console.log("%cprofileSharePreferencesChanged", 'background: #FF0000; color: white');
        sendGaEvent('send', 'event', "Profile", "GShare preferences changed", type);
    })
    $document.on("profileTextInfoChanged", (e, type) => {
        if (displayEventsInConsole) console.log("%cChanged display name or description", 'background: #FF0000; color: white');
        sendGaEvent('send', 'event', "Profile", "Changed display name or description", type);
    })
    $document.on("profileOpened", (e, type) => {
        if (displayEventsInConsole) console.log("%cprofileOpened", 'background: #FF0000; color: white');
        sendGaEvent('send', 'event', "Profile", "Opened");
    })
    $document.on("lpDashboardOpen", (e, type) => {
        if (displayEventsInConsole) console.log("%clpDashboardOpen", 'background: #FF0000; color: white');
        sendGaEvent('send', 'event', "LP dashboard", "liveProject Dashboard opened", type);
    })
    $document.on("dashboardSideMenuUsed", (e, type) => {
        if (displayEventsInConsole) console.log("%cdashboardSideMenuUsed", 'background: #FF0000; color: white');
        sendGaEvent('send', 'event', "LP dashboard", "LP dashboard side menu used", type);
    })
    $document.on("dashboardTimelineClicked", (e, type) => {
        if (displayEventsInConsole) console.log("%cdashboardTimelineClicked", 'background: #FF0000; color: white');
        sendGaEvent('send', 'event', "LP dashboard", "LP dashboard timeline clicked", type);
    })
    $document.on("dashboardMapClicked", (e, type) => {
        if (displayEventsInConsole) console.log("%cdashboardMapClicked", 'background: #FF0000; color: white');
        sendGaEvent('send', 'event', "LP dashboard", "Dashboard map clicked", type);
    })
    $document.on("dashboardMapSearchSolo", (e, type) => {
        if (displayEventsInConsole) console.log("%cdashboardMapSearchSolo", 'background: #FF0000; color: white');
        sendGaEvent('send', 'event', "LP dashboard", "Dashboard map search solo users", type);
    })
    $document.on("dashboardCalendarClicked", (e, type) => {
        if (displayEventsInConsole) console.log("%cCalendar clicked", 'background: #FF0000; color: white');
        sendGaEvent('send', 'event', "LP dashboard", "Dashboard calendar clicked", type);
    })
    $document.on("dashboardCalendarSearchSoloUser", (e, type) => {
        if (displayEventsInConsole) console.log("%cSearch solo in calendar", 'background: #FF0000; color: white');
        sendGaEvent('send', 'event', "LP dashboard", "Dashboard calendar search solo user", type);
    })
    $document.on("dashboardCalendarRefresh", (e, type) => {
        if (displayEventsInConsole) console.log("%cCalendar refresh", 'background: #FF0000; color: white');
        sendGaEvent('send', 'event', "LP dashboard", "Dashboard calendar refresh events", type);
    })
    $document.on("dashboardCalendarCreateEvent", (e, type) => {
        if (displayEventsInConsole) console.log("%cCalendar create event", 'background: #FF0000; color: white');
        sendGaEvent('send', 'event', "LP dashboard", "Dashboard calendar create event", type);
    })
    $document.on("dashboardCalendarEditEvent", (e, type) => {
        if (displayEventsInConsole) console.log("%cCalendar edit event", 'background: #FF0000; color: white');
        sendGaEvent('send', 'event', "LP dashboard", "Dashboard calendar edit event", type);
    })
    $document.on("dashboardCalendarReccuringEvents", (e, type) => {
        if (displayEventsInConsole) console.log("%cdashboardCalendarReccuringEvents", 'background: #FF0000; color: white');
        sendGaEvent('send', 'event', "LP dashboard", "Dashboard calendar reccuring event chosen", type);
    })
    $document.on("deliverableModuleCreateSubmission", (e, type) => {
        if (displayEventsInConsole) console.log("%cdeliverableModuleCreateSubmission", 'background: #FF0000; color: white');
        sendGaEvent('send', 'event', "LP deliverable module", "submit", type);
    })
    $document.on("deliverableModuleViewSubmissions", (e, type) => {
        if (displayEventsInConsole) console.log("%cdeliverableModuleViewSubmissions", 'background: #FF0000; color: white');
        sendGaEvent('send', 'event', "LP deliverable module", "view other submissions", type);
    })
    $document.on("deliverableModuleEditSubmission", (e, type) => {
        if (displayEventsInConsole) console.log("%cdeliverableModuleEditSubmission", 'background: #FF0000; color: white');
        sendGaEvent('send', 'event', "LP deliverable module", "edit submission", type);
    })
    $document.on("newLicenseDetected", (e, type) => {
        if (displayEventsInConsole) console.log("%cnewLicenseDetected", 'background: #FF0000; color: white');
        sendGaEvent('send', 'event', "newLicenseDetected");
    })
    $document.on("feedback", (e, type) => {
        if (displayEventsInConsole) console.log("%cfeedback", 'background: #FF0000; color: white');
        sendGaEvent('send', 'event', "Feedback");
    })
    $document.on("support", (e, type) => {
        if (displayEventsInConsole) console.log("%csupport", 'background: #FF0000; color: white');
        sendGaEvent('send', 'event', "Support");
    })
    $document.on("profileDiscussionPreferencesChanged", (e, type) => {
        if (displayEventsInConsole) console.log("%cprofileDiscussionPreferencesChanged", 'background: #FF0000; color: white');
        sendGaEvent('send', 'event', "lp discussion related emails", type);
    })
    $document.on("login", (e, type) => {
        if (displayEventsInConsole) console.log("%clogin", 'background: #FF0000; color: white');
        sendGaEvent('send', 'event', "login");
        const preparedObject = {
            event: 'logIn',
            userId: '' + type.userId
        };
        pushToDataLayer(preparedObject);
    })
    $document.on("searchMade", (e, data) => {
        setTimeout(() => {
            if (displayEventsInConsole) console.log("%csearch", 'background: #FF0000; color: white', "search", data);
            sendGaEvent('send', 'event', 'search', data);
            if (typeof fbq !== 'undefined') fbq('track', 'Search', {
                content_category: 'snippets',
                content_ids: 'woo-123',
                search_string: data
            });
        }, 50);

        let scope = data.scope;
        if (scope != "library" && currentCourse != null && currentCourse.id == data.scope) {
            scope = currentCourse.name;
        }
        else if (scope != "library" && availableCourses?.length) {
            let found = availableCourses.find(it => it.id == data.scope)
            if (found) {
                scope = found.name;
            }
        }
        const preparedObject = {
            event: 'search',
            search: [{
                query: '' + data.query,
                scope: '' + scope,
            }]
        }
        pushToDataLayer(preparedObject);
    });
    $document.on("filterMade", (e, data) => {
        setTimeout(() => {
            if (displayEventsInConsole) console.log("%csearch", 'background: #FF0000; color: white', "search", data);
            sendGaEvent('send', 'event', 'search', data);
            if (typeof fbq !== 'undefined') fbq('track', 'Search', {
                content_category: 'snippets',
                content_ids: 'woo-123',
                search_string: data
            });
        }, 50);

        let scope = data.scope;
        if (scope != "library" && currentCourse != null && currentCourse.id == data.scope) {
            scope = currentCourse.name;
        }
        else if (scope != "library" && availableCourses?.length) {
            let found = availableCourses.find(it => it.id == data.scope)
            if (found) {
                scope = found.name;
            }
        }
        const preparedObject = {
            event: 'search',
            search: [{
                query: '' + data.query,
                scope: '' + scope,
            }]
        }
        pushToDataLayer(preparedObject);
    });
    $document.on("impressions", (e, products: { id: number, title: string, category: string, brand: string }[], list: string) => {
        if (products == null || products.length == 0) { return; }
        const preparedObject = {
            event: 'eec.impressionView',
            ecommerce: {
                impressions: products.map((product, index) => {
                    return {
                        id: `${product.id}`,
                        name: product.title,
                        brand: `${product.brand}`,
                        category: fixCategories(product.category),
                        position: index + 1,
                        list: list
                    };
                })
            }
        }
        pushToDataLayer(preparedObject);
    });
    $document.on("previewModule", (e, products: { id: number, name: string, category: string, variant: string, brand: string }[], list: string) => {
        if (products == null || products.length == 0) { return; }
        const preparedObject = {
            event: 'eec.detail',
            ecommerce: {
                detail: {
                    actionField: {
                        list: 'preview chapter'
                    },
                    products: products?.map((product, index) => {
                        return {
                            id: `${product.id}`,
                            name: product.name,
                            variant: 'self-paced',
                            category: fixCategories(product.category),
                            brand: `${product.brand}`,
                        };
                    })
                }
            }
        }
        pushToDataLayer(preparedObject);
    });

    $document.on("moduleOpenedGTM", (e, data) => {
        pushToDataLayer(data);
    });
    $document.on("productPageGTM", (e, data) => {
        pushToDataLayer(data);
    });

    $document.on("impressionClick", (e, product: { id: number, title: string, category: string, position: number, brand: string }, list: string) => {
        if (product == null) { return; }
        const preparedObject = {
            event: 'eec.impressionClick',
            ecommerce: {
                click: {
                    actionField: {
                        list: list
                    },
                    products: [{
                        id: `${product.id}`,
                        name: product.title,
                        category: fixCategories(product.category),
                        position: product.position,
                        brand: `${product.brand}`,
                        list: list
                    }]
                }
            }
        }
        pushToDataLayer(preparedObject);
    });
}

function fixCategories(category: string): string {
    if (!category) { return ""; }

    return category.split(/;\s*/).map(it => it.trim()).sort().join(",");
}

export function pushToDataLayer(obj) {
    if (PlatformUtils.doesSupportCriteoGTM()) {
        if (isQA()) {
            console.log("%cPUSHING TO DATA LAYER", 'background: #FF0000; color: white', obj);
        }
        getDataLayer()?.push(obj);
    }
}

export function pushEventToDataLayer(obj) {
    if (PlatformUtils.doesSupportCriteoGTM()) {
        if (isQA()) {
            console.log("%cPUSHING TO DATA LAYER", 'background: #0000FF; color: white', obj);
        }
        getDataLayer()?.push(obj);
    }
}

export function getDataLayer(): any[] {
    (window as any).dataLayer = (window as any).dataLayer || [];
    return (window as any).dataLayer;
}

export function openInNewTab(url) {
    var win = window.open(url, '_blank');
    win.focus();
}

export function showPlaceholder() {
    let spinner = document.getElementById("sk-spinner-wrapper");
    if (spinner != null) {
        jQuery("#sk-spinner-wrapper").css({ "opacity": "1", "height": "auto" });
    }
}

export function hidePlaceholder() {
    let spinner = document.getElementById("sk-spinner-wrapper");
    if (spinner != null) {
        jQuery("#sk-spinner-wrapper").css({ "opacity": "0", "height": "0" });
    }
}

export function showPlaceholderScrambledVersion() {
    let spinner = document.getElementById("sk-spinner-wrapper-scrambled-version");
    if (spinner != null) {
        jQuery("#sk-spinner-wrapper-scrambled-version").css({ "opacity": "1", "height": "auto" });
    }
}

export function hidePlaceholderScrambledVersion() {
    let spinner = document.getElementById("sk-spinner-wrapper-scrambled-version");
    if (spinner != null) {
        jQuery("#sk-spinner-wrapper-scrambled-version").css({ "opacity": "0", "height": "0" });
    }
}

export function saveTemporarilyLocalStorage(key: string, data: any, expirationMs: number) {
    localStorage.setItem(key, JSON.stringify({
        value: JSON.stringify(data),
        timestamp: new Date().getTime() + expirationMs
    }));

    return data;
}

export function loadTemporarilyLocalStorage(key: string) {
    try {
        const record = JSON.parse(localStorage.getItem(key));
        if (!record) { return false; }
        return (new Date().getTime() < record.timestamp && JSON.parse(record.value));
    }
    catch (e) {
        return false;
    }
}


export function extractProgressData(course_id, unit_index, module_index, userProgress, courseDetails) {
    let current_progress_time = 0;
    let max_progress_time = 0;
    let total_video_time_from_progress = 0;
    let total_video_time_from_course_details = 0;
    let videoModuleType, lvViewerType;

    let isFound: boolean = false;

    if (userProgress != null) {
        userProgress.map((key, value) => {
            if (key.course_id == course_id && key.unit_index == unit_index && key.module_index == module_index) {
                current_progress_time = key.current_progress_time;
                max_progress_time = key.max_progress_time;
                total_video_time_from_progress = key.total_video_time;
                isFound = true;
            }
        })
    }

    if (courseDetails != null) {
        if (courseDetails != null) {
            for (let i = 0; i < courseDetails.units.length; i++) {
                let currentUnit = courseDetails.units[i];
                for (let j = 0; j < currentUnit.modules.length; j++) {
                    let currentModule = currentUnit.modules[j];
                    if (currentModule.module_index == module_index && currentUnit.unit_index == unit_index && courseDetails.id == course_id) {
                        total_video_time_from_course_details = currentModule.totalTime;
                        videoModuleType = currentModule.module_type;
                        lvViewerType = currentModule.lvViewerType;
                    }
                }
            }
        }
    }

    if (videoModuleType === VIDEO_MODULE_TYPE || (videoModuleType == LIVEVIDEO_VIEWER_MODULE_TYPE && lvViewerType === VIDEO_MODULE_TYPE)) {
        if (total_video_time_from_progress != null && total_video_time_from_course_details != null && !isNaN(Number(total_video_time_from_progress)) && !isNaN(Number(total_video_time_from_course_details)) && Number(total_video_time_from_progress) !== Number(total_video_time_from_course_details)) {
            if (current_progress_time > total_video_time_from_course_details) {
                current_progress_time = total_video_time_from_course_details;
            }
            if (max_progress_time > total_video_time_from_course_details) {
                max_progress_time = total_video_time_from_course_details;
            }
        }
    }

    let result = new Array();
    result.push(current_progress_time);
    result.push(max_progress_time);
    result.push(total_video_time_from_course_details);

    return result;
}


export function hideHotjarWidget() {
    if (!jQuery("#_hj_feedback_container").hasClass("hidden")) {
        jQuery("#_hj_feedback_container").addClass("hidden");
    }
}

export function showHotjarWidget() {
    if (jQuery("#_hj_feedback_container").hasClass("hidden")) {
        jQuery("#_hj_feedback_container").removeClass("hidden");
    }
}

export function divCollision($div1, $div2) {
    if ($div1 != null && $div2 != null && $div1.offset() != null && $div2.offset() != null) {
        var x1 = $div1.offset().left;
        var y1 = $div1.offset().top;
        var h1 = $div1.outerHeight(true);
        var w1 = $div1.outerWidth(true);
        var b1 = y1 + h1;
        var r1 = x1 + w1;
        var x2 = $div2.offset().left;
        var y2 = $div2.offset().top;
        var h2 = $div2.outerHeight(true);
        var w2 = $div2.outerWidth(true);
        var b2 = y2 + h2;
        var r2 = x2 + w2;

        if (b1 < y2 || y1 > b2 || r1 < x2 || x1 > r2) return false;
        return true;
    } else {
        return false;
    }
}


export function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function controlledAlert(x) {
    isQA() ? alert(x) : console.log("ERROR:", x);
}

export function exactIdFinder(id1: any, id2: any) {
    return Number(id1) == Number(id2) && !isNaN(Number(id1)) && !isNaN(Number(id2)) ? true : false;
}

export const compareModuleIndexes = (a, b) => {
    if (a.module_index < b.module_index)
        return -1;
    if (a.module_index > b.module_index)
        return 1;
    return 0;
}

export function newgativeUniqueIdGenerator() {
    var now: any = new Date();
    let new_id: any = (now.getMonth() < 9 ? '0' : '') + now.getMonth().toString();
    new_id += (now.getDate() < 10 ? '0' : '') + now.getDate().toString();
    new_id += (now.getHours() < 10 ? '0' : '') + now.getHours().toString();
    new_id += (now.getMinutes() < 10 ? '0' : '') + now.getMinutes().toString();
    new_id += (now.getSeconds() < 10 ? '0' : '') + now.getSeconds().toString();
    new_id += (now.getMilliseconds() < 10 ? '0' : '') + now.getMilliseconds().toString();

    new_id = - Number(new_id);
    return new_id;
}


export function setEndOfContenteditable(contentEditableElement) {
    var range, selection;
    let doc: any = document;
    if (document.createRange)//Firefox, Chrome, Opera, Safari, IE 9+
    {
        range = document.createRange();//Create a range (a range is a like the selection but invisible)
        if (range && contentEditableElement) {
            range.selectNodeContents(contentEditableElement);//Select the entire contents of the element with the range
            range.collapse(false);//collapse the range to the end point. false means collapse to end rather than the start
            selection = window.getSelection();//get the selection object (allows you to change selection)
            selection.removeAllRanges();//remove any selections already made
            selection.addRange(range);//make the range you have just created the visible selection
        }
    }
    else if (doc.selection)//IE 8 and lower
    {
        range = doc.body.createTextRange();//Create a range (a range is a like the selection but invisible)
        if (range && contentEditableElement) {
            range.moveToElementText(contentEditableElement);//Select the entire contents of the element with the range
            range.collapse(false);//collapse the range to the end point. false means collapse to end rather than the start
            range.select();//Select the range (make it the visible selection
        }
    }
}

export function insertAtCursor(myField, myValue) {
    let doc: any = document;
    //IE support
    if (doc.selection) {
        myField.focus();
        let sel = doc.selection.createRange();
        sel.text = myValue;
    }
    //MOZILLA and others
    else if (myField.selectionStart || myField.selectionStart == '0') {
        var startPos = myField.selectionStart;
        var endPos = myField.selectionEnd;
        myField.value = myField.value.substring(0, startPos)
            + myValue
            + myField.value.substring(endPos, myField.value.length);
    } else {
        myField.value += myValue;
    }
}

export function formatDate(date) {
    var monthNames = [
        "January", "February", "March",
        "April", "May", "June", "July",
        "August", "September", "October",
        "November", "December"
    ];

    var day = date.getDate();
    var monthIndex = date.getMonth();
    var year = date.getFullYear();

    return monthNames[monthIndex] + ' ' + day + ', ' + year;
}

export function trunc(str: string, n: number) {
    return (str.length > n) ? str.substr(0, n - 1) + '...' : str;
};


export function isLiveVideoPromotion() {
    var d = new Date();
    const CToffset = -5;
    var utc = d.getTime() + (d.getTimezoneOffset() * 60000);
    var nd = new Date(utc + (3600000 * CToffset));

    var month = nd.getMonth() + 1;
    var year = nd.getFullYear();
    let isPromotion = false;
    if (year === YEAR_FOR_PROMOTION && month === MONTH_FOR_PROMOTION) { //Promotion discount
        isPromotion = true;
    }

    if (getParameterByName("promotion") === "true") {
        isPromotion = true;
    }

    if (detectedApp() !== CURRENT_APP_LIVEVIDEO) {
        isPromotion = false;
    }

    return isPromotion;
};


export function handlePaste(e) {
    e.preventDefault();
    const win: any = window;
    var text = '';
    if (e.clipboardData || e.originalEvent.clipboardData) {
        text = (e.originalEvent || e).clipboardData.getData('text/plain');
    } else if (win.clipboardData) {
        text = win.clipboardData.getData('Text');
    }

    if (document.queryCommandSupported('insertText')) {
        document.execCommand('insertText', false, text);
    } else {
        document.execCommand('paste', false, text);
    }
}


export function mapModuleIdenToModulIdenUnique(moduleIden, courseDetails) {
    const mss = moduleIden.split('_');
    const courseID = mss[0];
    var unitIndex = mss[1];
    var moduleIndex = mss[2];

    const cUnit = courseDetails.units.find(it => Number(it.unit_index) == Number(unitIndex) && !isNaN(Number(unitIndex)))
    const uniqueUnitID = cUnit.unique_unit_id;
    const cModule = cUnit.modules.find(it => Number(it.module_index) == Number(moduleIndex) && !isNaN(Number(moduleIndex)))
    const uniqueModuleID = cModule.unique_module_id;

    return courseID + "_" + uniqueUnitID + "_" + uniqueModuleID;
}

export function toDateInputValue(input) {
    return input.toISOString().substring(0, 10);
};

export function makeid(length) {
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}

export function lastNameCapizalizedLetterWithFullStop(lastName) {
    if (!lastName) return;
    else {
        return (lastName && lastName[0] && lastName.toUpperCase()[0]) + ".";
    }
}

export function getNextDayOfWeek(date, dayOfWeek) {
    var resultDate = new Date(date.getTime());
    resultDate.setDate(date.getDate() + (7 + dayOfWeek - date.getDay()) % 7);
    return resultDate;
}

export function forceDownload(url, fileName) {
    if (!url) {
        throw new Error('"url" must be specified.');
    }

    var xhr = new XMLHttpRequest();

    xhr.responseType = 'blob';
    xhr.onload = function () {
        let win: any = window;
        var URL = window.URL || win.webkitURL;
        var imageUrl = URL.createObjectURL(xhr.response);
        var tag: any = document.createElement('a');

        tag.style = 'display: none';
        tag.href = imageUrl;

        if (fileName) {
            tag.download = fileName;
        }

        document.body.appendChild(tag);
        tag.click();
        document.body.removeChild(tag);
        URL.revokeObjectURL(url);
    };

    xhr.open('GET', url, true);
    xhr.send();
}

export function formatMoney(number: number) {
    return (number || 0).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
}

export function generateUniqueishNumber() {
    return Math.random();
}

export function getOffsetTop(element) {
    let offsetTop = 0;
    while (element) {
        offsetTop += element.offsetTop;
        element = element.offsetParent;
    }
    return offsetTop;
}

let RLLoadingCounter = 0;
export function RLLoadingFunction(props) {
    if (props.error) {
        RLLoadingCounter++;
        if (isQA()) console.log("RLLoadingFunction ERROR, retrying!!!!");
        if (RLLoadingCounter < 100) {
            setTimeout(() => {
                props.retry();
            }, 50);
        } else {
            isQA() && console.log("reload 1")
            location.reload();
        }
        return [];
    } else {
        return [];
    }
}

export function fixOrderingForGroupsForUser(group) {
    let result = group;
    if (group && group.groups) {
        result.groups = group.groups.map(g => {
            if (g.users && g.users.length) g.users = g.users.sort((a, b) => a.id - b.id)
            if (g.mentors && g.mentors.length) g.mentors = g.mentors.sort((a, b) => a.id - b.id)
            if (g.deliverables && g.deliverables.length) g.deliverables = g.deliverables.sort((a, b) => a.id - b.id)
            return g;
        })
    }
    return result;
}

export var deepDiffMapper = function () {
    return {
        VALUE_CREATED: 'created',
        VALUE_UPDATED: 'updated',
        VALUE_DELETED: 'deleted',
        VALUE_UNCHANGED: 'unchanged',
        map: function (obj1, obj2) {
            if (this.isFunction(obj1) || this.isFunction(obj2)) {
                throw 'Invalid argument. Function given, object expected.';
            }
            if (this.isValue(obj1) || this.isValue(obj2)) {
                return {
                    type: this.compareValues(obj1, obj2),
                    data: obj1 === undefined ? obj2 : obj1
                };
            }

            var diff = {};
            for (var key in obj1) {
                if (this.isFunction(obj1[key])) {
                    continue;
                }

                var value2 = undefined;
                if (obj2[key] !== undefined) {
                    value2 = obj2[key];
                }

                diff[key] = this.map(obj1[key], value2);
            }
            for (var key in obj2) {
                if (this.isFunction(obj2[key]) || diff[key] !== undefined) {
                    continue;
                }

                diff[key] = this.map(undefined, obj2[key]);
            }

            return diff;

        },
        compareValues: function (value1, value2) {
            if (value1 === value2) {
                return this.VALUE_UNCHANGED;
            }
            if (this.isDate(value1) && this.isDate(value2) && value1.getTime() === value2.getTime()) {
                return this.VALUE_UNCHANGED;
            }
            if (value1 === undefined) {
                return this.VALUE_CREATED;
            }
            if (value2 === undefined) {
                return this.VALUE_DELETED;
            }
            return this.VALUE_UPDATED;
        },
        isFunction: function (x) {
            return Object.prototype.toString.call(x) === '[object Function]';
        },
        isArray: function (x) {
            return Object.prototype.toString.call(x) === '[object Array]';
        },
        isDate: function (x) {
            return Object.prototype.toString.call(x) === '[object Date]';
        },
        isObject: function (x) {
            return Object.prototype.toString.call(x) === '[object Object]';
        },
        isValue: function (x) {
            return !this.isObject(x) && !this.isArray(x);
        }
    }
}();

// export function convertMinsToHrsMins(mins) {
//     let h: any = Math.floor(mins / 60);
//     let m: any = mins % 60;
//     h = h < 10 ? '0' + h : h;
//     m = m < 10 ? '0' + m : m;
//     return `${h}:${m}`;
// }

const pad = n => `0${n}`.slice(-2)
export function convertMinsToHrsMins(mins) {
    const date = new Date(mins * 60 * 1000)

    // Need to be UTC since timestamps are universal
    // but normal time methods operate based on local time.
    const hours = date.getUTCHours()
    const minutes = date.getUTCMinutes()

    // If 0, as in 00:00 or 12:00, default to 12.
    const hours12 = hours % 12 || 12
    const period = hours >= 12 ? 'pm' : 'am'

    return `${pad(hours12)}:${pad(minutes)}${period}`
}

export function multiDimensionalUnique(arr) {
    var uniques = [];
    var itemsFound = {};
    for (var i = 0, l = arr.length; i < l; i++) {
        var stringified = JSON.stringify(arr[i]);
        if (itemsFound[stringified]) { continue; }
        uniques.push(arr[i]);
        itemsFound[stringified] = true;
    }
    return uniques;
}

export function nameToDisplay(firstName, lastName, nickName, shouldDisplayNickName) {
    if (shouldDisplayNickName && nickName) {
        return nickName;
    }
    else {
        let newName = "";
        if (firstName) {
            newName += firstName;
        }

        if (lastName) {
            newName += (newName ? " " : "") + lastName;
        };

        return newName;
    }
}

export function trackPageView() {
    let displayEventsInConsole = isQA();
    const url = window.location.href;

    try {
        // if (!(url.indexOf("livevideo.manning.com") !== -1 || url.indexOf("liveproject.manning.com") !== -1)  ) { //if not liveVideo&liveProject
        //     ga('send', 'pageview');
        // }
    } catch (error) {

    }
    try {
        if (typeof fbq !== 'undefined') fbq('track', 'PageView');
    } catch (error) {

    }

    displayEventsInConsole && console.log("%cpage view", 'background: purple; color: yellow');
}

export function uniqueArrayOfObject(array, keyToBeUnique) {
    // Filter by looking at the next objects if the key is present a second time
    return array.filter((x, xi) => !array.slice(xi + 1)
        .some(y => y[keyToBeUnique] === x[keyToBeUnique]));
}

export function findFirstVisibleModule(courseId, userRoles = [ROLE_USER]) {
    return new Promise((resolve, reject) => {
        ServiceUtils.getActiveService().then(Service => {
            Service.getCourseStructure(courseId, userRoles).then(result => {
                let foundVisible = false;
                let moduleIden;
                let localURL;
                let productMainURL;
                result?.units?.forEach(unit => {
                    unit?.modules?.forEach(module => {
                        if (module.module_visible && !foundVisible) {
                            foundVisible = true;
                            moduleIden = `${courseId}_${unit.unit_index}_${module.module_index}`;
                            localURL = `/module/${moduleIden}`
                        }
                    });
                });
                let eCommURL = result.link_to_marketplace;
                if (PlatformUtils.isLiveProject()) {
                    productMainURL = `/project/${courseId}`
                } else if (PlatformUtils.isLiveVideo()) {
                    productMainURL = `/course/${courseId}`
                }
                resolve({
                    localURL: localURL,
                    eCommURL: eCommURL,
                    productMainURL: productMainURL,
                    moduleIden: moduleIden,
                })
            });
        });
    });
}

export function shouldDebug() {
    let debug = false;
    const url = window.location.href;
    if (
        url.indexOf("localhost") !== -1 ||
        url.indexOf("192.168.0.") !== -1 ||
        url.indexOf("livevideo-ui-dev") !== -1 ||
        url.indexOf("lv-test-ui") !== -1 ||
        url.indexOf("d23vewbo0wjc8b.cloudfront.net") !== -1 ||
        url.indexOf("lp-test-ui") !== -1 ||
        url.indexOf("dlc9nze5anfoi.cloudfront.net") !== -1 ||
        url.indexOf("lv-test-prod-ui") !== -1 ||
        url.indexOf("livevideo-qa.manning") !== -1 ||
        url.indexOf("pbc-qa.manning") !== -1 ||
        url.indexOf("liveproject-qa.manning") !== -1) {
        debug = true;
    }
    if (getParameterByName("verbose") === "true") {
        debug = true;
    }
    return debug;
}